import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {
  WheelIcon,
  ShieldNoBorder,
  covidAmens,
  PickupIcon,
  DropoffIcon,
  GsbLogoBold,
  Clock,
  SeatErrorIcon,
  TripIcon,
  TickMarkIcon,
  FareDownArrow,
  FareUpArrow,
} from "../common/icons/svg";
import { updateCheckoutDet, updateLevyAndConcession, updateLoader, updateSeatChartErrorMsg, updateOrderToken, updateShowpassenger } from "../../actions/search-actions";
import store from "../../store";
import { apiUrl, color, FLYBUSDISC } from "../common/constants";
import FemaleSeatAlert from "../common/femaleSeatAlert";
import {
  getRevDate,
  get24HoursTime,
  fetchGet,
  fetchPost,
} from "../../common/common";
import { renderImg } from "../common/icons/img";
import Passenger from "../checkout/passenger";
import { customSort } from "../common/helper";

import {
  t, SELECT_SEAT, SELECT_PADP, SELECT_BOARDING_POINT, SELECT_DROPPING_POINT, SELECTED, BOOKED, AVAILABLE, FEMALE, GRAND_TOTAL, SHOW_DETAILS, HIDE_DETAILS, TOTAL_FARE_DETAILS, PROVIDE_PASSENGER_DETAILS, CLOSE_CUSTOMER_DETAILS, SELECT_PDTC,
  SELECT, SEATS, BOARDING, DROPPING_POINT, UPPER, LOWER, SEATER, SLEEPER, BERTH
} from "../../translations/SeatChart";


class Seatchart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showLoad: true,
      seatchart: [],
      stchrt: [],
      error: false,
      fares: [],
      selFare: 0,
      selPick: "",
      selDrop: "",
      selSeat: [],
      selSeatFare: [],
      seatFare: 0,
      disSeatFare: 0,
      chargePer: 0,
      chargeRs: 0,
      showPoint: "",
      countLower: 0,
      countUpper: 0,
      HasSeater: 0,
      HasSleeper: 0,
      extraFare1: 0,
      extraFare2: 0,
      totalSeat: 0,
      Covid19Config: false,
      seaterror: false,
      alerterror: "",
      pickuplistnew: [],
      dropofflistnew: [],
      showlinkfromcity: false,
      showlinktocity: false,
      linkfare1: 0,
      linkfare2: 0,
      picklinkTime: "",
      picklinkUpID: "",
      picklinkUpName: "",
      picklinkUpAddress: "",
      picklinkUpLandmark: "",
      picklinkUpPhone: "",
      droplinktime: "",
      picklinkcity: "",
      droplinkcity: "",
      droplinkUpID: "",
      ismantispg: false,
      logintoken: "",
      showStationInfromcity: false,
      showStationIntocity: false,
      pickStationName: "",
      pickStationTime: "",
      pickStationId: "",
      pickStationAddress: "",
      pickStationLandmark: "",
      pickStationPhone: "",
      dropStationName: "",
      dropStationTime: "",
      dropStationId: "",
      showFemalePopup: false,
      selseatVal: {},
      totalOnwardSeats: 0,
      returnChartSeatRestrictionFlag: false,
      openfareModal: false,
      gst: 0,
      baseFare: 0,
      levyDetails: {},
      levyNameArray: [],
      levyArray: [],
      levyTotal: 0,
      lvcndata: {},
      showPassenger: [],
      postData: {},
      groupDiscount: 0,
      orderData: {},
      onConAmt: 0,
      returnTripDiscPer: 10,
      pickCharge: 0,
      dropCharge: 0,
      // pickSelectedIndex: -1,
      // dropSelectedIndex: -1,
      // currentItemIndex: -1,
      currentpickItemIndex: -1,
      currentdropItemIndex: -1,
      isflexibus :false,
      tmpBaseFare:0,
      flexibusPaxCount:0,
      flexibusAdultFare:0,
      flexibusChildFare:0
    };
    this.pickupDropdownRef = React.createRef();
    this.dropdownRef = React.createRef();
  }

  componentDidMount() {
    store.dispatch(updateCheckoutDet({}))
    const that = this;
    let url =
      window.url +
      apiUrl.chart +
      "?routeID=" +
      this.props.seat.RouteScheduleId +
      "&journeyDate=" +
      getRevDate(this.props.search.searchParams.departDate);

    if (this.props.isSingleLady == 1) {
      url += '&IsSingleLady=1';
    }
    store.dispatch(updateLoader(false));
    fetchGet(url)
      .then(function (data) {
        // data = {
        //   "APIGetChartMicrositeResult": {
        //     "ErrorMessage": "",
        //     "Seats": [
        //       {
        //         "Agent": 0,
        //         "BaseFare": 288,
        //         "BkgType": "",
        //         "BusTypeID": 16,
        //         "BusTypeName": "KARNATAKA SARIGE",
        //         "ChartName": null,
        //         "ChildFare": 144,
        //         "ColumnNo": 0,
        //         "CompanyChartID": 58,
        //         "CompanyChartName": "KS 49 NEW BACK DOOR",
        //         "Deck": 1,
        //         "DefaultCurrencyID": 1,
        //         "Fare": 288,
        //         "GST": 0,
        //         "Gender": "",
        //         "HasDoubleSeaterFemaleValidation": false,
        //         "HasDoubleSlpFemaleValidation": false,
        //         "HasFemaleValidation": false,
        //         "HasGST": 0,
        //         "HasGenderCheck": true,
        //         "HasSCharge": 0,
        //         "HasSTax": 0,
        //         "Height": 1,
        //         "IsAC": false,
        //         "IsAisle": false,
        //         "IsAvailable": 0,
        //         "IsSeatBlockedForCovid19": 0,
        //         "RouteCode": "54~40~1661~894~2024-03-12",
        //         "RowNo": 0,
        //         "SeatLabel": "49",
        //         "SeatTypeID": 1,
        //         "ServiceCharge": 0,
        //         "ServiceTax": 0,
        //         "Width": 1
        //       },
        //       {
        //         "Agent": 0,
        //         "BaseFare": 0,
        //         "BkgType": "",
        //         "BusTypeID": 16,
        //         "BusTypeName": "KARNATAKA SARIGE",
        //         "ChartName": null,
        //         "ChildFare": 0,
        //         "ColumnNo": 1,
        //         "CompanyChartID": 58,
        //         "CompanyChartName": "KS 49 NEW BACK DOOR",
        //         "Deck": 1,
        //         "DefaultCurrencyID": 1,
        //         "Fare": 0,
        //         "GST": 0,
        //         "Gender": "",
        //         "HasDoubleSeaterFemaleValidation": false,
        //         "HasDoubleSlpFemaleValidation": false,
        //         "HasFemaleValidation": false,
        //         "HasGST": 0,
        //         "HasGenderCheck": true,
        //         "HasSCharge": 0,
        //         "HasSTax": 0,
        //         "Height": 1,
        //         "IsAC": false,
        //         "IsAisle": true,
        //         "IsAvailable": 0,
        //         "IsSeatBlockedForCovid19": 0,
        //         "RouteCode": "54~40~1661~894~2024-03-12",
        //         "RowNo": 0,
        //         "SeatLabel": "",
        //         "SeatTypeID": 4,
        //         "ServiceCharge": 0,
        //         "ServiceTax": 0,
        //         "Width": 1
        //       },
        //       {
        //         "Agent": 0,
        //         "BaseFare": 0,
        //         "BkgType": "",
        //         "BusTypeID": 16,
        //         "BusTypeName": "KARNATAKA SARIGE",
        //         "ChartName": null,
        //         "ChildFare": 0,
        //         "ColumnNo": 2,
        //         "CompanyChartID": 58,
        //         "CompanyChartName": "KS 49 NEW BACK DOOR",
        //         "Deck": 1,
        //         "DefaultCurrencyID": 1,
        //         "Fare": 0,
        //         "GST": 0,
        //         "Gender": "",
        //         "HasDoubleSeaterFemaleValidation": false,
        //         "HasDoubleSlpFemaleValidation": false,
        //         "HasFemaleValidation": false,
        //         "HasGST": 0,
        //         "HasGenderCheck": true,
        //         "HasSCharge": 0,
        //         "HasSTax": 0,
        //         "Height": 1,
        //         "IsAC": false,
        //         "IsAisle": true,
        //         "IsAvailable": 0,
        //         "IsSeatBlockedForCovid19": 0,
        //         "RouteCode": "54~40~1661~894~2024-03-12",
        //         "RowNo": 0,
        //         "SeatLabel": "",
        //         "SeatTypeID": 4,
        //         "ServiceCharge": 0,
        //         "ServiceTax": 0,
        //         "Width": 1
        //       },
        //       {
        //         "Agent": 0,
        //         "BaseFare": 0,
        //         "BkgType": "",
        //         "BusTypeID": 16,
        //         "BusTypeName": "KARNATAKA SARIGE",
        //         "ChartName": null,
        //         "ChildFare": 0,
        //         "ColumnNo": 3,
        //         "CompanyChartID": 58,
        //         "CompanyChartName": "KS 49 NEW BACK DOOR",
        //         "Deck": 1,
        //         "DefaultCurrencyID": 1,
        //         "Fare": 0,
        //         "GST": 0,
        //         "Gender": "F",
        //         "HasDoubleSeaterFemaleValidation": false,
        //         "HasDoubleSlpFemaleValidation": false,
        //         "HasFemaleValidation": false,
        //         "HasGST": 0,
        //         "HasGenderCheck": true,
        //         "HasSCharge": 0,
        //         "HasSTax": 0,
        //         "Height": 1,
        //         "IsAC": false,
        //         "IsAisle": true,
        //         "IsAvailable": 1,
        //         "IsSeatBlockedForCovid19": 0,
        //         "RouteCode": "54~40~1661~894~2024-03-12",
        //         "RowNo": 0,
        //         "SeatLabel": "",
        //         "SeatTypeID": 4,
        //         "ServiceCharge": 0,
        //         "ServiceTax": 0,
        //         "Width": 1
        //       },
        //       {
        //         "Agent": 0,
        //         "BaseFare": 0,
        //         "BkgType": "",
        //         "BusTypeID": 16,
        //         "BusTypeName": "KARNATAKA SARIGE",
        //         "ChartName": null,
        //         "ChildFare": 0,
        //         "ColumnNo": 4,
        //         "CompanyChartID": 58,
        //         "CompanyChartName": "KS 49 NEW BACK DOOR",
        //         "Deck": 1,
        //         "DefaultCurrencyID": 1,
        //         "Fare": 0,
        //         "GST": 0,
        //         "Gender": "M",
        //         "HasDoubleSeaterFemaleValidation": false,
        //         "HasDoubleSlpFemaleValidation": false,
        //         "HasFemaleValidation": false,
        //         "HasGST": 0,
        //         "HasGenderCheck": true,
        //         "HasSCharge": 0,
        //         "HasSTax": 0,
        //         "Height": 1,
        //         "IsAC": false,
        //         "IsAisle": true,
        //         "IsAvailable": 1,
        //         "IsSeatBlockedForCovid19": 0,
        //         "RouteCode": "54~40~1661~894~2024-03-12",
        //         "RowNo": 0,
        //         "SeatLabel": "",
        //         "SeatTypeID": 4,
        //         "ServiceCharge": 0,
        //         "ServiceTax": 0,
        //         "Width": 1
        //       },
        //       {
        //         "Agent": 0,
        //         "BaseFare": 0,
        //         "BkgType": "",
        //         "BusTypeID": 16,
        //         "BusTypeName": "KARNATAKA SARIGE",
        //         "ChartName": null,
        //         "ChildFare": 0,
        //         "ColumnNo": 5,
        //         "CompanyChartID": 58,
        //         "CompanyChartName": "KS 49 NEW BACK DOOR",
        //         "Deck": 1,
        //         "DefaultCurrencyID": 1,
        //         "Fare": 0,
        //         "GST": 0,
        //         "Gender": "",
        //         "HasDoubleSeaterFemaleValidation": false,
        //         "HasDoubleSlpFemaleValidation": false,
        //         "HasFemaleValidation": false,
        //         "HasGST": 0,
        //         "HasGenderCheck": true,
        //         "HasSCharge": 0,
        //         "HasSTax": 0,
        //         "Height": 1,
        //         "IsAC": false,
        //         "IsAisle": true,
        //         "IsAvailable": 1,
        //         "IsSeatBlockedForCovid19": 0,
        //         "RouteCode": "54~40~1661~894~2024-03-12",
        //         "RowNo": 0,
        //         "SeatLabel": "",
        //         "SeatTypeID": 4,
        //         "ServiceCharge": 0,
        //         "ServiceTax": 0,
        //         "Width": 1
        //       },
        //       {
        //         "Agent": 0,
        //         "BaseFare": 288,
        //         "BkgType": "",
        //         "BusTypeID": 16,
        //         "BusTypeName": "KARNATAKA SARIGE",
        //         "ChartName": null,
        //         "ChildFare": 144,
        //         "ColumnNo": 0,
        //         "CompanyChartID": 58,
        //         "CompanyChartName": "KS 49 NEW BACK DOOR",
        //         "Deck": 1,
        //         "DefaultCurrencyID": 1,
        //         "Fare": 288,
        //         "GST": 0,
        //         "Gender": "M",
        //         "HasDoubleSeaterFemaleValidation": false,
        //         "HasDoubleSlpFemaleValidation": false,
        //         "HasFemaleValidation": false,
        //         "HasGST": 0,
        //         "HasGenderCheck": true,
        //         "HasSCharge": 0,
        //         "HasSTax": 0,
        //         "Height": 1,
        //         "IsAC": false,
        //         "IsAisle": false,
        //         "IsAvailable": 1,
        //         "IsSeatBlockedForCovid19": 0,
        //         "RouteCode": "54~40~1661~894~2024-03-12",
        //         "RowNo": 1,
        //         "SeatLabel": "5",
        //         "SeatTypeID": 1,
        //         "ServiceCharge": 0,
        //         "ServiceTax": 0,
        //         "Width": 1
        //       },
        //       {
        //         "Agent": 0,
        //         "BaseFare": 288,
        //         "BkgType": "",
        //         "BusTypeID": 16,
        //         "BusTypeName": "KARNATAKA SARIGE",
        //         "ChartName": null,
        //         "ChildFare": 144,
        //         "ColumnNo": 1,
        //         "CompanyChartID": 58,
        //         "CompanyChartName": "KS 49 NEW BACK DOOR",
        //         "Deck": 1,
        //         "DefaultCurrencyID": 1,
        //         "Fare": 288,
        //         "GST": 0,
        //         "Gender": "",
        //         "HasDoubleSeaterFemaleValidation": false,
        //         "HasDoubleSlpFemaleValidation": false,
        //         "HasFemaleValidation": false,
        //         "HasGST": 0,
        //         "HasGenderCheck": true,
        //         "HasSCharge": 0,
        //         "HasSTax": 0,
        //         "Height": 1,
        //         "IsAC": false,
        //         "IsAisle": false,
        //         "IsAvailable": 0,
        //         "IsSeatBlockedForCovid19": 0,
        //         "RouteCode": "54~40~1661~894~2024-03-12",
        //         "RowNo": 1,
        //         "SeatLabel": "4",
        //         "SeatTypeID": 1,
        //         "ServiceCharge": 0,
        //         "ServiceTax": 0,
        //         "Width": 1
        //       },
        //       {
        //         "Agent": 0,
        //         "BaseFare": 0,
        //         "BkgType": "",
        //         "BusTypeID": 16,
        //         "BusTypeName": "KARNATAKA SARIGE",
        //         "ChartName": null,
        //         "ChildFare": 0,
        //         "ColumnNo": 2,
        //         "CompanyChartID": 58,
        //         "CompanyChartName": "KS 49 NEW BACK DOOR",
        //         "Deck": 1,
        //         "DefaultCurrencyID": 1,
        //         "Fare": 0,
        //         "GST": 0,
        //         "Gender": "",
        //         "HasDoubleSeaterFemaleValidation": false,
        //         "HasDoubleSlpFemaleValidation": false,
        //         "HasFemaleValidation": false,
        //         "HasGST": 0,
        //         "HasGenderCheck": true,
        //         "HasSCharge": 0,
        //         "HasSTax": 0,
        //         "Height": 1,
        //         "IsAC": false,
        //         "IsAisle": true,
        //         "IsAvailable": 1,
        //         "IsSeatBlockedForCovid19": 0,
        //         "RouteCode": "54~40~1661~894~2024-03-12",
        //         "RowNo": 1,
        //         "SeatLabel": "",
        //         "SeatTypeID": 4,
        //         "ServiceCharge": 0,
        //         "ServiceTax": 0,
        //         "Width": 1
        //       },
        //       {
        //         "Agent": 0,
        //         "BaseFare": 288,
        //         "BkgType": "",
        //         "BusTypeID": 16,
        //         "BusTypeName": "KARNATAKA SARIGE",
        //         "ChartName": null,
        //         "ChildFare": 144,
        //         "ColumnNo": 3,
        //         "CompanyChartID": 58,
        //         "CompanyChartName": "KS 49 NEW BACK DOOR",
        //         "Deck": 1,
        //         "DefaultCurrencyID": 1,
        //         "Fare": 288,
        //         "GST": 0,
        //         "Gender": "",
        //         "HasDoubleSeaterFemaleValidation": false,
        //         "HasDoubleSlpFemaleValidation": false,
        //         "HasFemaleValidation": false,
        //         "HasGST": 0,
        //         "HasGenderCheck": true,
        //         "HasSCharge": 0,
        //         "HasSTax": 0,
        //         "Height": 1,
        //         "IsAC": false,
        //         "IsAisle": false,
        //         "IsAvailable": 1,
        //         "IsSeatBlockedForCovid19": 0,
        //         "RouteCode": "54~40~1661~894~2024-03-12",
        //         "RowNo": 1,
        //         "SeatLabel": "3",
        //         "SeatTypeID": 1,
        //         "ServiceCharge": 0,
        //         "ServiceTax": 0,
        //         "Width": 1
        //       },
        //       {
        //         "Agent": 0,
        //         "BaseFare": 288,
        //         "BkgType": "",
        //         "BusTypeID": 16,
        //         "BusTypeName": "KARNATAKA SARIGE",
        //         "ChartName": null,
        //         "ChildFare": 144,
        //         "ColumnNo": 4,
        //         "CompanyChartID": 58,
        //         "CompanyChartName": "KS 49 NEW BACK DOOR",
        //         "Deck": 1,
        //         "DefaultCurrencyID": 1,
        //         "Fare": 288,
        //         "GST": 0,
        //         "Gender": "",
        //         "HasDoubleSeaterFemaleValidation": false,
        //         "HasDoubleSlpFemaleValidation": false,
        //         "HasFemaleValidation": false,
        //         "HasGST": 0,
        //         "HasGenderCheck": true,
        //         "HasSCharge": 0,
        //         "HasSTax": 0,
        //         "Height": 1,
        //         "IsAC": false,
        //         "IsAisle": false,
        //         "IsAvailable": 1,
        //         "IsSeatBlockedForCovid19": 0,
        //         "RouteCode": "54~40~1661~894~2024-03-12",
        //         "RowNo": 1,
        //         "SeatLabel": "2",
        //         "SeatTypeID": 1,
        //         "ServiceCharge": 0,
        //         "ServiceTax": 0,
        //         "Width": 1
        //       },
        //       {
        //         "Agent": 0,
        //         "BaseFare": 288,
        //         "BkgType": "",
        //         "BusTypeID": 16,
        //         "BusTypeName": "KARNATAKA SARIGE",
        //         "ChartName": null,
        //         "ChildFare": 144,
        //         "ColumnNo": 5,
        //         "CompanyChartID": 58,
        //         "CompanyChartName": "KS 49 NEW BACK DOOR",
        //         "Deck": 1,
        //         "DefaultCurrencyID": 1,
        //         "Fare": 288,
        //         "GST": 0,
        //         "Gender": "",
        //         "HasDoubleSeaterFemaleValidation": false,
        //         "HasDoubleSlpFemaleValidation": false,
        //         "HasFemaleValidation": false,
        //         "HasGST": 0,
        //         "HasGenderCheck": true,
        //         "HasSCharge": 0,
        //         "HasSTax": 0,
        //         "Height": 1,
        //         "IsAC": false,
        //         "IsAisle": false,
        //         "IsAvailable": 1,
        //         "IsSeatBlockedForCovid19": 0,
        //         "RouteCode": "54~40~1661~894~2024-03-12",
        //         "RowNo": 1,
        //         "SeatLabel": "1",
        //         "SeatTypeID": 1,
        //         "ServiceCharge": 0,
        //         "ServiceTax": 0,
        //         "Width": 1
        //       },
        //       {
        //         "Agent": 0,
        //         "BaseFare": 288,
        //         "BkgType": "",
        //         "BusTypeID": 16,
        //         "BusTypeName": "KARNATAKA SARIGE",
        //         "ChartName": null,
        //         "ChildFare": 144,
        //         "ColumnNo": 0,
        //         "CompanyChartID": 58,
        //         "CompanyChartName": "KS 49 NEW BACK DOOR",
        //         "Deck": 1,
        //         "DefaultCurrencyID": 1,
        //         "Fare": 288,
        //         "GST": 0,
        //         "Gender": "",
        //         "HasDoubleSeaterFemaleValidation": false,
        //         "HasDoubleSlpFemaleValidation": false,
        //         "HasFemaleValidation": false,
        //         "HasGST": 0,
        //         "HasGenderCheck": true,
        //         "HasSCharge": 0,
        //         "HasSTax": 0,
        //         "Height": 1,
        //         "IsAC": false,
        //         "IsAisle": false,
        //         "IsAvailable": 1,
        //         "IsSeatBlockedForCovid19": 0,
        //         "RouteCode": "54~40~1661~894~2024-03-12",
        //         "RowNo": 2,
        //         "SeatLabel": "6",
        //         "SeatTypeID": 1,
        //         "ServiceCharge": 0,
        //         "ServiceTax": 0,
        //         "Width": 1
        //       },
        //       {
        //         "Agent": 0,
        //         "BaseFare": 288,
        //         "BkgType": "",
        //         "BusTypeID": 16,
        //         "BusTypeName": "KARNATAKA SARIGE",
        //         "ChartName": null,
        //         "ChildFare": 144,
        //         "ColumnNo": 1,
        //         "CompanyChartID": 58,
        //         "CompanyChartName": "KS 49 NEW BACK DOOR",
        //         "Deck": 1,
        //         "DefaultCurrencyID": 1,
        //         "Fare": 288,
        //         "GST": 0,
        //         "Gender": "",
        //         "HasDoubleSeaterFemaleValidation": false,
        //         "HasDoubleSlpFemaleValidation": false,
        //         "HasFemaleValidation": false,
        //         "HasGST": 0,
        //         "HasGenderCheck": true,
        //         "HasSCharge": 0,
        //         "HasSTax": 0,
        //         "Height": 1,
        //         "IsAC": false,
        //         "IsAisle": false,
        //         "IsAvailable": 1,
        //         "IsSeatBlockedForCovid19": 0,
        //         "RouteCode": "54~40~1661~894~2024-03-12",
        //         "RowNo": 2,
        //         "SeatLabel": "7",
        //         "SeatTypeID": 1,
        //         "ServiceCharge": 0,
        //         "ServiceTax": 0,
        //         "Width": 1
        //       },
        //       {
        //         "Agent": 0,
        //         "BaseFare": 0,
        //         "BkgType": "",
        //         "BusTypeID": 16,
        //         "BusTypeName": "KARNATAKA SARIGE",
        //         "ChartName": null,
        //         "ChildFare": 0,
        //         "ColumnNo": 2,
        //         "CompanyChartID": 58,
        //         "CompanyChartName": "KS 49 NEW BACK DOOR",
        //         "Deck": 1,
        //         "DefaultCurrencyID": 1,
        //         "Fare": 0,
        //         "GST": 0,
        //         "Gender": "",
        //         "HasDoubleSeaterFemaleValidation": false,
        //         "HasDoubleSlpFemaleValidation": false,
        //         "HasFemaleValidation": false,
        //         "HasGST": 0,
        //         "HasGenderCheck": true,
        //         "HasSCharge": 0,
        //         "HasSTax": 0,
        //         "Height": 1,
        //         "IsAC": false,
        //         "IsAisle": true,
        //         "IsAvailable": 1,
        //         "IsSeatBlockedForCovid19": 0,
        //         "RouteCode": "54~40~1661~894~2024-03-12",
        //         "RowNo": 2,
        //         "SeatLabel": "",
        //         "SeatTypeID": 4,
        //         "ServiceCharge": 0,
        //         "ServiceTax": 0,
        //         "Width": 1
        //       },
        //       {
        //         "Agent": 0,
        //         "BaseFare": 288,
        //         "BkgType": "",
        //         "BusTypeID": 16,
        //         "BusTypeName": "KARNATAKA SARIGE",
        //         "ChartName": null,
        //         "ChildFare": 144,
        //         "ColumnNo": 3,
        //         "CompanyChartID": 58,
        //         "CompanyChartName": "KS 49 NEW BACK DOOR",
        //         "Deck": 1,
        //         "DefaultCurrencyID": 1,
        //         "Fare": 288,
        //         "GST": 0,
        //         "Gender": "",
        //         "HasDoubleSeaterFemaleValidation": false,
        //         "HasDoubleSlpFemaleValidation": false,
        //         "HasFemaleValidation": false,
        //         "HasGST": 0,
        //         "HasGenderCheck": true,
        //         "HasSCharge": 0,
        //         "HasSTax": 0,
        //         "Height": 1,
        //         "IsAC": false,
        //         "IsAisle": false,
        //         "IsAvailable": 1,
        //         "IsSeatBlockedForCovid19": 0,
        //         "RouteCode": "54~40~1661~894~2024-03-12",
        //         "RowNo": 2,
        //         "SeatLabel": "8",
        //         "SeatTypeID": 1,
        //         "ServiceCharge": 0,
        //         "ServiceTax": 0,
        //         "Width": 1
        //       },
        //       {
        //         "Agent": 0,
        //         "BaseFare": 288,
        //         "BkgType": "",
        //         "BusTypeID": 16,
        //         "BusTypeName": "KARNATAKA SARIGE",
        //         "ChartName": null,
        //         "ChildFare": 144,
        //         "ColumnNo": 4,
        //         "CompanyChartID": 58,
        //         "CompanyChartName": "KS 49 NEW BACK DOOR",
        //         "Deck": 1,
        //         "DefaultCurrencyID": 1,
        //         "Fare": 288,
        //         "GST": 0,
        //         "Gender": "",
        //         "HasDoubleSeaterFemaleValidation": false,
        //         "HasDoubleSlpFemaleValidation": false,
        //         "HasFemaleValidation": false,
        //         "HasGST": 0,
        //         "HasGenderCheck": true,
        //         "HasSCharge": 0,
        //         "HasSTax": 0,
        //         "Height": 1,
        //         "IsAC": false,
        //         "IsAisle": false,
        //         "IsAvailable": 1,
        //         "IsSeatBlockedForCovid19": 0,
        //         "RouteCode": "54~40~1661~894~2024-03-12",
        //         "RowNo": 2,
        //         "SeatLabel": "9",
        //         "SeatTypeID": 1,
        //         "ServiceCharge": 0,
        //         "ServiceTax": 0,
        //         "Width": 1
        //       },
        //       {
        //         "Agent": 0,
        //         "BaseFare": 288,
        //         "BkgType": "",
        //         "BusTypeID": 16,
        //         "BusTypeName": "KARNATAKA SARIGE",
        //         "ChartName": null,
        //         "ChildFare": 144,
        //         "ColumnNo": 5,
        //         "CompanyChartID": 58,
        //         "CompanyChartName": "KS 49 NEW BACK DOOR",
        //         "Deck": 1,
        //         "DefaultCurrencyID": 1,
        //         "Fare": 288,
        //         "GST": 0,
        //         "Gender": "",
        //         "HasDoubleSeaterFemaleValidation": false,
        //         "HasDoubleSlpFemaleValidation": false,
        //         "HasFemaleValidation": false,
        //         "HasGST": 0,
        //         "HasGenderCheck": true,
        //         "HasSCharge": 0,
        //         "HasSTax": 0,
        //         "Height": 1,
        //         "IsAC": false,
        //         "IsAisle": false,
        //         "IsAvailable": 1,
        //         "IsSeatBlockedForCovid19": 0,
        //         "RouteCode": "54~40~1661~894~2024-03-12",
        //         "RowNo": 2,
        //         "SeatLabel": "10",
        //         "SeatTypeID": 1,
        //         "ServiceCharge": 0,
        //         "ServiceTax": 0,
        //         "Width": 1
        //       },
        //       {
        //         "Agent": 0,
        //         "BaseFare": 288,
        //         "BkgType": "",
        //         "BusTypeID": 16,
        //         "BusTypeName": "KARNATAKA SARIGE",
        //         "ChartName": null,
        //         "ChildFare": 144,
        //         "ColumnNo": 0,
        //         "CompanyChartID": 58,
        //         "CompanyChartName": "KS 49 NEW BACK DOOR",
        //         "Deck": 1,
        //         "DefaultCurrencyID": 1,
        //         "Fare": 288,
        //         "GST": 0,
        //         "Gender": "",
        //         "HasDoubleSeaterFemaleValidation": false,
        //         "HasDoubleSlpFemaleValidation": false,
        //         "HasFemaleValidation": false,
        //         "HasGST": 0,
        //         "HasGenderCheck": true,
        //         "HasSCharge": 0,
        //         "HasSTax": 0,
        //         "Height": 1,
        //         "IsAC": false,
        //         "IsAisle": false,
        //         "IsAvailable": 1,
        //         "IsSeatBlockedForCovid19": 0,
        //         "RouteCode": "54~40~1661~894~2024-03-12",
        //         "RowNo": 3,
        //         "SeatLabel": "15",
        //         "SeatTypeID": 1,
        //         "ServiceCharge": 0,
        //         "ServiceTax": 0,
        //         "Width": 1
        //       },
        //       {
        //         "Agent": 0,
        //         "BaseFare": 288,
        //         "BkgType": "",
        //         "BusTypeID": 16,
        //         "BusTypeName": "KARNATAKA SARIGE",
        //         "ChartName": null,
        //         "ChildFare": 144,
        //         "ColumnNo": 1,
        //         "CompanyChartID": 58,
        //         "CompanyChartName": "KS 49 NEW BACK DOOR",
        //         "Deck": 1,
        //         "DefaultCurrencyID": 1,
        //         "Fare": 288,
        //         "GST": 0,
        //         "Gender": "",
        //         "HasDoubleSeaterFemaleValidation": false,
        //         "HasDoubleSlpFemaleValidation": false,
        //         "HasFemaleValidation": false,
        //         "HasGST": 0,
        //         "HasGenderCheck": true,
        //         "HasSCharge": 0,
        //         "HasSTax": 0,
        //         "Height": 1,
        //         "IsAC": false,
        //         "IsAisle": false,
        //         "IsAvailable": 1,
        //         "IsSeatBlockedForCovid19": 0,
        //         "RouteCode": "54~40~1661~894~2024-03-12",
        //         "RowNo": 3,
        //         "SeatLabel": "14",
        //         "SeatTypeID": 1,
        //         "ServiceCharge": 0,
        //         "ServiceTax": 0,
        //         "Width": 1
        //       },
        //       {
        //         "Agent": 0,
        //         "BaseFare": 0,
        //         "BkgType": "",
        //         "BusTypeID": 16,
        //         "BusTypeName": "KARNATAKA SARIGE",
        //         "ChartName": null,
        //         "ChildFare": 0,
        //         "ColumnNo": 2,
        //         "CompanyChartID": 58,
        //         "CompanyChartName": "KS 49 NEW BACK DOOR",
        //         "Deck": 1,
        //         "DefaultCurrencyID": 1,
        //         "Fare": 0,
        //         "GST": 0,
        //         "Gender": "",
        //         "HasDoubleSeaterFemaleValidation": false,
        //         "HasDoubleSlpFemaleValidation": false,
        //         "HasFemaleValidation": false,
        //         "HasGST": 0,
        //         "HasGenderCheck": true,
        //         "HasSCharge": 0,
        //         "HasSTax": 0,
        //         "Height": 1,
        //         "IsAC": false,
        //         "IsAisle": true,
        //         "IsAvailable": 1,
        //         "IsSeatBlockedForCovid19": 0,
        //         "RouteCode": "54~40~1661~894~2024-03-12",
        //         "RowNo": 3,
        //         "SeatLabel": "",
        //         "SeatTypeID": 4,
        //         "ServiceCharge": 0,
        //         "ServiceTax": 0,
        //         "Width": 1
        //       },
        //       {
        //         "Agent": 0,
        //         "BaseFare": 288,
        //         "BkgType": "",
        //         "BusTypeID": 16,
        //         "BusTypeName": "KARNATAKA SARIGE",
        //         "ChartName": null,
        //         "ChildFare": 144,
        //         "ColumnNo": 3,
        //         "CompanyChartID": 58,
        //         "CompanyChartName": "KS 49 NEW BACK DOOR",
        //         "Deck": 1,
        //         "DefaultCurrencyID": 1,
        //         "Fare": 288,
        //         "GST": 0,
        //         "Gender": "",
        //         "HasDoubleSeaterFemaleValidation": false,
        //         "HasDoubleSlpFemaleValidation": false,
        //         "HasFemaleValidation": false,
        //         "HasGST": 0,
        //         "HasGenderCheck": true,
        //         "HasSCharge": 0,
        //         "HasSTax": 0,
        //         "Height": 1,
        //         "IsAC": false,
        //         "IsAisle": false,
        //         "IsAvailable": 1,
        //         "IsSeatBlockedForCovid19": 0,
        //         "RouteCode": "54~40~1661~894~2024-03-12",
        //         "RowNo": 3,
        //         "SeatLabel": "13",
        //         "SeatTypeID": 1,
        //         "ServiceCharge": 0,
        //         "ServiceTax": 0,
        //         "Width": 1
        //       },
        //       {
        //         "Agent": 0,
        //         "BaseFare": 288,
        //         "BkgType": "",
        //         "BusTypeID": 16,
        //         "BusTypeName": "KARNATAKA SARIGE",
        //         "ChartName": null,
        //         "ChildFare": 144,
        //         "ColumnNo": 4,
        //         "CompanyChartID": 58,
        //         "CompanyChartName": "KS 49 NEW BACK DOOR",
        //         "Deck": 1,
        //         "DefaultCurrencyID": 1,
        //         "Fare": 288,
        //         "GST": 0,
        //         "Gender": "",
        //         "HasDoubleSeaterFemaleValidation": false,
        //         "HasDoubleSlpFemaleValidation": false,
        //         "HasFemaleValidation": false,
        //         "HasGST": 0,
        //         "HasGenderCheck": true,
        //         "HasSCharge": 0,
        //         "HasSTax": 0,
        //         "Height": 1,
        //         "IsAC": false,
        //         "IsAisle": false,
        //         "IsAvailable": 1,
        //         "IsSeatBlockedForCovid19": 0,
        //         "RouteCode": "54~40~1661~894~2024-03-12",
        //         "RowNo": 3,
        //         "SeatLabel": "12",
        //         "SeatTypeID": 1,
        //         "ServiceCharge": 0,
        //         "ServiceTax": 0,
        //         "Width": 1
        //       },
        //       {
        //         "Agent": 0,
        //         "BaseFare": 288,
        //         "BkgType": "",
        //         "BusTypeID": 16,
        //         "BusTypeName": "KARNATAKA SARIGE",
        //         "ChartName": null,
        //         "ChildFare": 144,
        //         "ColumnNo": 5,
        //         "CompanyChartID": 58,
        //         "CompanyChartName": "KS 49 NEW BACK DOOR",
        //         "Deck": 1,
        //         "DefaultCurrencyID": 1,
        //         "Fare": 288,
        //         "GST": 0,
        //         "Gender": "",
        //         "HasDoubleSeaterFemaleValidation": false,
        //         "HasDoubleSlpFemaleValidation": false,
        //         "HasFemaleValidation": false,
        //         "HasGST": 0,
        //         "HasGenderCheck": true,
        //         "HasSCharge": 0,
        //         "HasSTax": 0,
        //         "Height": 1,
        //         "IsAC": false,
        //         "IsAisle": false,
        //         "IsAvailable": 1,
        //         "IsSeatBlockedForCovid19": 0,
        //         "RouteCode": "54~40~1661~894~2024-03-12",
        //         "RowNo": 3,
        //         "SeatLabel": "11",
        //         "SeatTypeID": 1,
        //         "ServiceCharge": 0,
        //         "ServiceTax": 0,
        //         "Width": 1
        //       },
        //       {
        //         "Agent": 0,
        //         "BaseFare": 288,
        //         "BkgType": "",
        //         "BusTypeID": 16,
        //         "BusTypeName": "KARNATAKA SARIGE",
        //         "ChartName": null,
        //         "ChildFare": 144,
        //         "ColumnNo": 0,
        //         "CompanyChartID": 58,
        //         "CompanyChartName": "KS 49 NEW BACK DOOR",
        //         "Deck": 1,
        //         "DefaultCurrencyID": 1,
        //         "Fare": 288,
        //         "GST": 0,
        //         "Gender": "",
        //         "HasDoubleSeaterFemaleValidation": false,
        //         "HasDoubleSlpFemaleValidation": false,
        //         "HasFemaleValidation": false,
        //         "HasGST": 0,
        //         "HasGenderCheck": true,
        //         "HasSCharge": 0,
        //         "HasSTax": 0,
        //         "Height": 1,
        //         "IsAC": false,
        //         "IsAisle": false,
        //         "IsAvailable": 1,
        //         "IsSeatBlockedForCovid19": 0,
        //         "RouteCode": "54~40~1661~894~2024-03-12",
        //         "RowNo": 4,
        //         "SeatLabel": "16",
        //         "SeatTypeID": 1,
        //         "ServiceCharge": 0,
        //         "ServiceTax": 0,
        //         "Width": 1
        //       },
        //       {
        //         "Agent": 0,
        //         "BaseFare": 288,
        //         "BkgType": "",
        //         "BusTypeID": 16,
        //         "BusTypeName": "KARNATAKA SARIGE",
        //         "ChartName": null,
        //         "ChildFare": 144,
        //         "ColumnNo": 1,
        //         "CompanyChartID": 58,
        //         "CompanyChartName": "KS 49 NEW BACK DOOR",
        //         "Deck": 1,
        //         "DefaultCurrencyID": 1,
        //         "Fare": 288,
        //         "GST": 0,
        //         "Gender": "",
        //         "HasDoubleSeaterFemaleValidation": false,
        //         "HasDoubleSlpFemaleValidation": false,
        //         "HasFemaleValidation": false,
        //         "HasGST": 0,
        //         "HasGenderCheck": true,
        //         "HasSCharge": 0,
        //         "HasSTax": 0,
        //         "Height": 1,
        //         "IsAC": false,
        //         "IsAisle": false,
        //         "IsAvailable": 1,
        //         "IsSeatBlockedForCovid19": 0,
        //         "RouteCode": "54~40~1661~894~2024-03-12",
        //         "RowNo": 4,
        //         "SeatLabel": "17",
        //         "SeatTypeID": 1,
        //         "ServiceCharge": 0,
        //         "ServiceTax": 0,
        //         "Width": 1
        //       },
        //       {
        //         "Agent": 0,
        //         "BaseFare": 0,
        //         "BkgType": "",
        //         "BusTypeID": 16,
        //         "BusTypeName": "KARNATAKA SARIGE",
        //         "ChartName": null,
        //         "ChildFare": 0,
        //         "ColumnNo": 2,
        //         "CompanyChartID": 58,
        //         "CompanyChartName": "KS 49 NEW BACK DOOR",
        //         "Deck": 1,
        //         "DefaultCurrencyID": 1,
        //         "Fare": 0,
        //         "GST": 0,
        //         "Gender": "",
        //         "HasDoubleSeaterFemaleValidation": false,
        //         "HasDoubleSlpFemaleValidation": false,
        //         "HasFemaleValidation": false,
        //         "HasGST": 0,
        //         "HasGenderCheck": true,
        //         "HasSCharge": 0,
        //         "HasSTax": 0,
        //         "Height": 1,
        //         "IsAC": false,
        //         "IsAisle": true,
        //         "IsAvailable": 1,
        //         "IsSeatBlockedForCovid19": 0,
        //         "RouteCode": "54~40~1661~894~2024-03-12",
        //         "RowNo": 4,
        //         "SeatLabel": "",
        //         "SeatTypeID": 4,
        //         "ServiceCharge": 0,
        //         "ServiceTax": 0,
        //         "Width": 1
        //       },
        //       {
        //         "Agent": 0,
        //         "BaseFare": 288,
        //         "BkgType": "",
        //         "BusTypeID": 16,
        //         "BusTypeName": "KARNATAKA SARIGE",
        //         "ChartName": null,
        //         "ChildFare": 144,
        //         "ColumnNo": 3,
        //         "CompanyChartID": 58,
        //         "CompanyChartName": "KS 49 NEW BACK DOOR",
        //         "Deck": 1,
        //         "DefaultCurrencyID": 1,
        //         "Fare": 288,
        //         "GST": 0,
        //         "Gender": "",
        //         "HasDoubleSeaterFemaleValidation": false,
        //         "HasDoubleSlpFemaleValidation": false,
        //         "HasFemaleValidation": false,
        //         "HasGST": 0,
        //         "HasGenderCheck": true,
        //         "HasSCharge": 0,
        //         "HasSTax": 0,
        //         "Height": 1,
        //         "IsAC": false,
        //         "IsAisle": false,
        //         "IsAvailable": 1,
        //         "IsSeatBlockedForCovid19": 0,
        //         "RouteCode": "54~40~1661~894~2024-03-12",
        //         "RowNo": 4,
        //         "SeatLabel": "18",
        //         "SeatTypeID": 1,
        //         "ServiceCharge": 0,
        //         "ServiceTax": 0,
        //         "Width": 1
        //       },
        //       {
        //         "Agent": 0,
        //         "BaseFare": 288,
        //         "BkgType": "",
        //         "BusTypeID": 16,
        //         "BusTypeName": "KARNATAKA SARIGE",
        //         "ChartName": null,
        //         "ChildFare": 144,
        //         "ColumnNo": 4,
        //         "CompanyChartID": 58,
        //         "CompanyChartName": "KS 49 NEW BACK DOOR",
        //         "Deck": 1,
        //         "DefaultCurrencyID": 1,
        //         "Fare": 288,
        //         "GST": 0,
        //         "Gender": "",
        //         "HasDoubleSeaterFemaleValidation": false,
        //         "HasDoubleSlpFemaleValidation": false,
        //         "HasFemaleValidation": false,
        //         "HasGST": 0,
        //         "HasGenderCheck": true,
        //         "HasSCharge": 0,
        //         "HasSTax": 0,
        //         "Height": 1,
        //         "IsAC": false,
        //         "IsAisle": false,
        //         "IsAvailable": 1,
        //         "IsSeatBlockedForCovid19": 0,
        //         "RouteCode": "54~40~1661~894~2024-03-12",
        //         "RowNo": 4,
        //         "SeatLabel": "19",
        //         "SeatTypeID": 1,
        //         "ServiceCharge": 0,
        //         "ServiceTax": 0,
        //         "Width": 1
        //       },
        //       {
        //         "Agent": 0,
        //         "BaseFare": 288,
        //         "BkgType": "",
        //         "BusTypeID": 16,
        //         "BusTypeName": "KARNATAKA SARIGE",
        //         "ChartName": null,
        //         "ChildFare": 144,
        //         "ColumnNo": 5,
        //         "CompanyChartID": 58,
        //         "CompanyChartName": "KS 49 NEW BACK DOOR",
        //         "Deck": 1,
        //         "DefaultCurrencyID": 1,
        //         "Fare": 288,
        //         "GST": 0,
        //         "Gender": "",
        //         "HasDoubleSeaterFemaleValidation": false,
        //         "HasDoubleSlpFemaleValidation": false,
        //         "HasFemaleValidation": false,
        //         "HasGST": 0,
        //         "HasGenderCheck": true,
        //         "HasSCharge": 0,
        //         "HasSTax": 0,
        //         "Height": 1,
        //         "IsAC": false,
        //         "IsAisle": false,
        //         "IsAvailable": 1,
        //         "IsSeatBlockedForCovid19": 0,
        //         "RouteCode": "54~40~1661~894~2024-03-12",
        //         "RowNo": 4,
        //         "SeatLabel": "20",
        //         "SeatTypeID": 1,
        //         "ServiceCharge": 0,
        //         "ServiceTax": 0,
        //         "Width": 1
        //       },
        //       {
        //         "Agent": 0,
        //         "BaseFare": 288,
        //         "BkgType": "",
        //         "BusTypeID": 16,
        //         "BusTypeName": "KARNATAKA SARIGE",
        //         "ChartName": null,
        //         "ChildFare": 144,
        //         "ColumnNo": 0,
        //         "CompanyChartID": 58,
        //         "CompanyChartName": "KS 49 NEW BACK DOOR",
        //         "Deck": 1,
        //         "DefaultCurrencyID": 1,
        //         "Fare": 288,
        //         "GST": 0,
        //         "Gender": "",
        //         "HasDoubleSeaterFemaleValidation": false,
        //         "HasDoubleSlpFemaleValidation": false,
        //         "HasFemaleValidation": false,
        //         "HasGST": 0,
        //         "HasGenderCheck": true,
        //         "HasSCharge": 0,
        //         "HasSTax": 0,
        //         "Height": 1,
        //         "IsAC": false,
        //         "IsAisle": false,
        //         "IsAvailable": 1,
        //         "IsSeatBlockedForCovid19": 0,
        //         "RouteCode": "54~40~1661~894~2024-03-12",
        //         "RowNo": 5,
        //         "SeatLabel": "25",
        //         "SeatTypeID": 1,
        //         "ServiceCharge": 0,
        //         "ServiceTax": 0,
        //         "Width": 1
        //       },
        //       {
        //         "Agent": 0,
        //         "BaseFare": 288,
        //         "BkgType": "",
        //         "BusTypeID": 16,
        //         "BusTypeName": "KARNATAKA SARIGE",
        //         "ChartName": null,
        //         "ChildFare": 144,
        //         "ColumnNo": 1,
        //         "CompanyChartID": 58,
        //         "CompanyChartName": "KS 49 NEW BACK DOOR",
        //         "Deck": 1,
        //         "DefaultCurrencyID": 1,
        //         "Fare": 288,
        //         "GST": 0,
        //         "Gender": "",
        //         "HasDoubleSeaterFemaleValidation": false,
        //         "HasDoubleSlpFemaleValidation": false,
        //         "HasFemaleValidation": false,
        //         "HasGST": 0,
        //         "HasGenderCheck": true,
        //         "HasSCharge": 0,
        //         "HasSTax": 0,
        //         "Height": 1,
        //         "IsAC": false,
        //         "IsAisle": false,
        //         "IsAvailable": 1,
        //         "IsSeatBlockedForCovid19": 0,
        //         "RouteCode": "54~40~1661~894~2024-03-12",
        //         "RowNo": 5,
        //         "SeatLabel": "24",
        //         "SeatTypeID": 1,
        //         "ServiceCharge": 0,
        //         "ServiceTax": 0,
        //         "Width": 1
        //       },
        //       {
        //         "Agent": 0,
        //         "BaseFare": 0,
        //         "BkgType": "",
        //         "BusTypeID": 16,
        //         "BusTypeName": "KARNATAKA SARIGE",
        //         "ChartName": null,
        //         "ChildFare": 0,
        //         "ColumnNo": 2,
        //         "CompanyChartID": 58,
        //         "CompanyChartName": "KS 49 NEW BACK DOOR",
        //         "Deck": 1,
        //         "DefaultCurrencyID": 1,
        //         "Fare": 0,
        //         "GST": 0,
        //         "Gender": "",
        //         "HasDoubleSeaterFemaleValidation": false,
        //         "HasDoubleSlpFemaleValidation": false,
        //         "HasFemaleValidation": false,
        //         "HasGST": 0,
        //         "HasGenderCheck": true,
        //         "HasSCharge": 0,
        //         "HasSTax": 0,
        //         "Height": 1,
        //         "IsAC": false,
        //         "IsAisle": true,
        //         "IsAvailable": 1,
        //         "IsSeatBlockedForCovid19": 0,
        //         "RouteCode": "54~40~1661~894~2024-03-12",
        //         "RowNo": 5,
        //         "SeatLabel": "",
        //         "SeatTypeID": 4,
        //         "ServiceCharge": 0,
        //         "ServiceTax": 0,
        //         "Width": 1
        //       },
        //       {
        //         "Agent": 0,
        //         "BaseFare": 288,
        //         "BkgType": "",
        //         "BusTypeID": 16,
        //         "BusTypeName": "KARNATAKA SARIGE",
        //         "ChartName": null,
        //         "ChildFare": 144,
        //         "ColumnNo": 3,
        //         "CompanyChartID": 58,
        //         "CompanyChartName": "KS 49 NEW BACK DOOR",
        //         "Deck": 1,
        //         "DefaultCurrencyID": 1,
        //         "Fare": 288,
        //         "GST": 0,
        //         "Gender": "",
        //         "HasDoubleSeaterFemaleValidation": false,
        //         "HasDoubleSlpFemaleValidation": false,
        //         "HasFemaleValidation": false,
        //         "HasGST": 0,
        //         "HasGenderCheck": true,
        //         "HasSCharge": 0,
        //         "HasSTax": 0,
        //         "Height": 1,
        //         "IsAC": false,
        //         "IsAisle": false,
        //         "IsAvailable": 1,
        //         "IsSeatBlockedForCovid19": 0,
        //         "RouteCode": "54~40~1661~894~2024-03-12",
        //         "RowNo": 5,
        //         "SeatLabel": "23",
        //         "SeatTypeID": 1,
        //         "ServiceCharge": 0,
        //         "ServiceTax": 0,
        //         "Width": 1
        //       },
        //       {
        //         "Agent": 0,
        //         "BaseFare": 288,
        //         "BkgType": "",
        //         "BusTypeID": 16,
        //         "BusTypeName": "KARNATAKA SARIGE",
        //         "ChartName": null,
        //         "ChildFare": 144,
        //         "ColumnNo": 4,
        //         "CompanyChartID": 58,
        //         "CompanyChartName": "KS 49 NEW BACK DOOR",
        //         "Deck": 1,
        //         "DefaultCurrencyID": 1,
        //         "Fare": 288,
        //         "GST": 0,
        //         "Gender": "",
        //         "HasDoubleSeaterFemaleValidation": false,
        //         "HasDoubleSlpFemaleValidation": false,
        //         "HasFemaleValidation": false,
        //         "HasGST": 0,
        //         "HasGenderCheck": true,
        //         "HasSCharge": 0,
        //         "HasSTax": 0,
        //         "Height": 1,
        //         "IsAC": false,
        //         "IsAisle": false,
        //         "IsAvailable": 1,
        //         "IsSeatBlockedForCovid19": 0,
        //         "RouteCode": "54~40~1661~894~2024-03-12",
        //         "RowNo": 5,
        //         "SeatLabel": "22",
        //         "SeatTypeID": 1,
        //         "ServiceCharge": 0,
        //         "ServiceTax": 0,
        //         "Width": 1
        //       },
        //       {
        //         "Agent": 0,
        //         "BaseFare": 288,
        //         "BkgType": "",
        //         "BusTypeID": 16,
        //         "BusTypeName": "KARNATAKA SARIGE",
        //         "ChartName": null,
        //         "ChildFare": 144,
        //         "ColumnNo": 5,
        //         "CompanyChartID": 58,
        //         "CompanyChartName": "KS 49 NEW BACK DOOR",
        //         "Deck": 1,
        //         "DefaultCurrencyID": 1,
        //         "Fare": 288,
        //         "GST": 0,
        //         "Gender": "",
        //         "HasDoubleSeaterFemaleValidation": false,
        //         "HasDoubleSlpFemaleValidation": false,
        //         "HasFemaleValidation": false,
        //         "HasGST": 0,
        //         "HasGenderCheck": true,
        //         "HasSCharge": 0,
        //         "HasSTax": 0,
        //         "Height": 1,
        //         "IsAC": false,
        //         "IsAisle": false,
        //         "IsAvailable": 1,
        //         "IsSeatBlockedForCovid19": 0,
        //         "RouteCode": "54~40~1661~894~2024-03-12",
        //         "RowNo": 5,
        //         "SeatLabel": "21",
        //         "SeatTypeID": 1,
        //         "ServiceCharge": 0,
        //         "ServiceTax": 0,
        //         "Width": 1
        //       },
        //       {
        //         "Agent": 0,
        //         "BaseFare": 288,
        //         "BkgType": "",
        //         "BusTypeID": 16,
        //         "BusTypeName": "KARNATAKA SARIGE",
        //         "ChartName": null,
        //         "ChildFare": 144,
        //         "ColumnNo": 0,
        //         "CompanyChartID": 58,
        //         "CompanyChartName": "KS 49 NEW BACK DOOR",
        //         "Deck": 1,
        //         "DefaultCurrencyID": 1,
        //         "Fare": 288,
        //         "GST": 0,
        //         "Gender": "",
        //         "HasDoubleSeaterFemaleValidation": false,
        //         "HasDoubleSlpFemaleValidation": false,
        //         "HasFemaleValidation": false,
        //         "HasGST": 0,
        //         "HasGenderCheck": true,
        //         "HasSCharge": 0,
        //         "HasSTax": 0,
        //         "Height": 1,
        //         "IsAC": false,
        //         "IsAisle": false,
        //         "IsAvailable": 1,
        //         "IsSeatBlockedForCovid19": 0,
        //         "RouteCode": "54~40~1661~894~2024-03-12",
        //         "RowNo": 6,
        //         "SeatLabel": "26",
        //         "SeatTypeID": 1,
        //         "ServiceCharge": 0,
        //         "ServiceTax": 0,
        //         "Width": 1
        //       },
        //       {
        //         "Agent": 0,
        //         "BaseFare": 288,
        //         "BkgType": "",
        //         "BusTypeID": 16,
        //         "BusTypeName": "KARNATAKA SARIGE",
        //         "ChartName": null,
        //         "ChildFare": 144,
        //         "ColumnNo": 1,
        //         "CompanyChartID": 58,
        //         "CompanyChartName": "KS 49 NEW BACK DOOR",
        //         "Deck": 1,
        //         "DefaultCurrencyID": 1,
        //         "Fare": 288,
        //         "GST": 0,
        //         "Gender": "",
        //         "HasDoubleSeaterFemaleValidation": false,
        //         "HasDoubleSlpFemaleValidation": false,
        //         "HasFemaleValidation": false,
        //         "HasGST": 0,
        //         "HasGenderCheck": true,
        //         "HasSCharge": 0,
        //         "HasSTax": 0,
        //         "Height": 1,
        //         "IsAC": false,
        //         "IsAisle": false,
        //         "IsAvailable": 1,
        //         "IsSeatBlockedForCovid19": 0,
        //         "RouteCode": "54~40~1661~894~2024-03-12",
        //         "RowNo": 6,
        //         "SeatLabel": "27",
        //         "SeatTypeID": 1,
        //         "ServiceCharge": 0,
        //         "ServiceTax": 0,
        //         "Width": 1
        //       },
        //       {
        //         "Agent": 0,
        //         "BaseFare": 0,
        //         "BkgType": "",
        //         "BusTypeID": 16,
        //         "BusTypeName": "KARNATAKA SARIGE",
        //         "ChartName": null,
        //         "ChildFare": 0,
        //         "ColumnNo": 2,
        //         "CompanyChartID": 58,
        //         "CompanyChartName": "KS 49 NEW BACK DOOR",
        //         "Deck": 1,
        //         "DefaultCurrencyID": 1,
        //         "Fare": 0,
        //         "GST": 0,
        //         "Gender": "",
        //         "HasDoubleSeaterFemaleValidation": false,
        //         "HasDoubleSlpFemaleValidation": false,
        //         "HasFemaleValidation": false,
        //         "HasGST": 0,
        //         "HasGenderCheck": true,
        //         "HasSCharge": 0,
        //         "HasSTax": 0,
        //         "Height": 1,
        //         "IsAC": false,
        //         "IsAisle": true,
        //         "IsAvailable": 1,
        //         "IsSeatBlockedForCovid19": 0,
        //         "RouteCode": "54~40~1661~894~2024-03-12",
        //         "RowNo": 6,
        //         "SeatLabel": "",
        //         "SeatTypeID": 4,
        //         "ServiceCharge": 0,
        //         "ServiceTax": 0,
        //         "Width": 1
        //       },
        //       {
        //         "Agent": 0,
        //         "BaseFare": 288,
        //         "BkgType": "",
        //         "BusTypeID": 16,
        //         "BusTypeName": "KARNATAKA SARIGE",
        //         "ChartName": null,
        //         "ChildFare": 144,
        //         "ColumnNo": 3,
        //         "CompanyChartID": 58,
        //         "CompanyChartName": "KS 49 NEW BACK DOOR",
        //         "Deck": 1,
        //         "DefaultCurrencyID": 1,
        //         "Fare": 288,
        //         "GST": 0,
        //         "Gender": "",
        //         "HasDoubleSeaterFemaleValidation": false,
        //         "HasDoubleSlpFemaleValidation": false,
        //         "HasFemaleValidation": false,
        //         "HasGST": 0,
        //         "HasGenderCheck": true,
        //         "HasSCharge": 0,
        //         "HasSTax": 0,
        //         "Height": 1,
        //         "IsAC": false,
        //         "IsAisle": false,
        //         "IsAvailable": 1,
        //         "IsSeatBlockedForCovid19": 0,
        //         "RouteCode": "54~40~1661~894~2024-03-12",
        //         "RowNo": 6,
        //         "SeatLabel": "28",
        //         "SeatTypeID": 1,
        //         "ServiceCharge": 0,
        //         "ServiceTax": 0,
        //         "Width": 1
        //       },
        //       {
        //         "Agent": 0,
        //         "BaseFare": 288,
        //         "BkgType": "",
        //         "BusTypeID": 16,
        //         "BusTypeName": "KARNATAKA SARIGE",
        //         "ChartName": null,
        //         "ChildFare": 144,
        //         "ColumnNo": 4,
        //         "CompanyChartID": 58,
        //         "CompanyChartName": "KS 49 NEW BACK DOOR",
        //         "Deck": 1,
        //         "DefaultCurrencyID": 1,
        //         "Fare": 288,
        //         "GST": 0,
        //         "Gender": "",
        //         "HasDoubleSeaterFemaleValidation": false,
        //         "HasDoubleSlpFemaleValidation": false,
        //         "HasFemaleValidation": false,
        //         "HasGST": 0,
        //         "HasGenderCheck": true,
        //         "HasSCharge": 0,
        //         "HasSTax": 0,
        //         "Height": 1,
        //         "IsAC": false,
        //         "IsAisle": false,
        //         "IsAvailable": 1,
        //         "IsSeatBlockedForCovid19": 0,
        //         "RouteCode": "54~40~1661~894~2024-03-12",
        //         "RowNo": 6,
        //         "SeatLabel": "29",
        //         "SeatTypeID": 1,
        //         "ServiceCharge": 0,
        //         "ServiceTax": 0,
        //         "Width": 1
        //       },
        //       {
        //         "Agent": 0,
        //         "BaseFare": 288,
        //         "BkgType": "",
        //         "BusTypeID": 16,
        //         "BusTypeName": "KARNATAKA SARIGE",
        //         "ChartName": null,
        //         "ChildFare": 144,
        //         "ColumnNo": 5,
        //         "CompanyChartID": 58,
        //         "CompanyChartName": "KS 49 NEW BACK DOOR",
        //         "Deck": 1,
        //         "DefaultCurrencyID": 1,
        //         "Fare": 288,
        //         "GST": 0,
        //         "Gender": "",
        //         "HasDoubleSeaterFemaleValidation": false,
        //         "HasDoubleSlpFemaleValidation": false,
        //         "HasFemaleValidation": false,
        //         "HasGST": 0,
        //         "HasGenderCheck": true,
        //         "HasSCharge": 0,
        //         "HasSTax": 0,
        //         "Height": 1,
        //         "IsAC": false,
        //         "IsAisle": false,
        //         "IsAvailable": 1,
        //         "IsSeatBlockedForCovid19": 0,
        //         "RouteCode": "54~40~1661~894~2024-03-12",
        //         "RowNo": 6,
        //         "SeatLabel": "30",
        //         "SeatTypeID": 1,
        //         "ServiceCharge": 0,
        //         "ServiceTax": 0,
        //         "Width": 1
        //       },
        //       {
        //         "Agent": 0,
        //         "BaseFare": 288,
        //         "BkgType": "",
        //         "BusTypeID": 16,
        //         "BusTypeName": "KARNATAKA SARIGE",
        //         "ChartName": null,
        //         "ChildFare": 144,
        //         "ColumnNo": 0,
        //         "CompanyChartID": 58,
        //         "CompanyChartName": "KS 49 NEW BACK DOOR",
        //         "Deck": 1,
        //         "DefaultCurrencyID": 1,
        //         "Fare": 288,
        //         "GST": 0,
        //         "Gender": "",
        //         "HasDoubleSeaterFemaleValidation": false,
        //         "HasDoubleSlpFemaleValidation": false,
        //         "HasFemaleValidation": false,
        //         "HasGST": 0,
        //         "HasGenderCheck": true,
        //         "HasSCharge": 0,
        //         "HasSTax": 0,
        //         "Height": 1,
        //         "IsAC": false,
        //         "IsAisle": false,
        //         "IsAvailable": 1,
        //         "IsSeatBlockedForCovid19": 0,
        //         "RouteCode": "54~40~1661~894~2024-03-12",
        //         "RowNo": 7,
        //         "SeatLabel": "35",
        //         "SeatTypeID": 1,
        //         "ServiceCharge": 0,
        //         "ServiceTax": 0,
        //         "Width": 1
        //       },
        //       {
        //         "Agent": 0,
        //         "BaseFare": 288,
        //         "BkgType": "",
        //         "BusTypeID": 16,
        //         "BusTypeName": "KARNATAKA SARIGE",
        //         "ChartName": null,
        //         "ChildFare": 144,
        //         "ColumnNo": 1,
        //         "CompanyChartID": 58,
        //         "CompanyChartName": "KS 49 NEW BACK DOOR",
        //         "Deck": 1,
        //         "DefaultCurrencyID": 1,
        //         "Fare": 288,
        //         "GST": 0,
        //         "Gender": "",
        //         "HasDoubleSeaterFemaleValidation": false,
        //         "HasDoubleSlpFemaleValidation": false,
        //         "HasFemaleValidation": false,
        //         "HasGST": 0,
        //         "HasGenderCheck": true,
        //         "HasSCharge": 0,
        //         "HasSTax": 0,
        //         "Height": 1,
        //         "IsAC": false,
        //         "IsAisle": false,
        //         "IsAvailable": 1,
        //         "IsSeatBlockedForCovid19": 0,
        //         "RouteCode": "54~40~1661~894~2024-03-12",
        //         "RowNo": 7,
        //         "SeatLabel": "34",
        //         "SeatTypeID": 1,
        //         "ServiceCharge": 0,
        //         "ServiceTax": 0,
        //         "Width": 1
        //       },
        //       {
        //         "Agent": 0,
        //         "BaseFare": 0,
        //         "BkgType": "",
        //         "BusTypeID": 16,
        //         "BusTypeName": "KARNATAKA SARIGE",
        //         "ChartName": null,
        //         "ChildFare": 0,
        //         "ColumnNo": 2,
        //         "CompanyChartID": 58,
        //         "CompanyChartName": "KS 49 NEW BACK DOOR",
        //         "Deck": 1,
        //         "DefaultCurrencyID": 1,
        //         "Fare": 0,
        //         "GST": 0,
        //         "Gender": "",
        //         "HasDoubleSeaterFemaleValidation": false,
        //         "HasDoubleSlpFemaleValidation": false,
        //         "HasFemaleValidation": false,
        //         "HasGST": 0,
        //         "HasGenderCheck": true,
        //         "HasSCharge": 0,
        //         "HasSTax": 0,
        //         "Height": 1,
        //         "IsAC": false,
        //         "IsAisle": true,
        //         "IsAvailable": 1,
        //         "IsSeatBlockedForCovid19": 0,
        //         "RouteCode": "54~40~1661~894~2024-03-12",
        //         "RowNo": 7,
        //         "SeatLabel": "",
        //         "SeatTypeID": 4,
        //         "ServiceCharge": 0,
        //         "ServiceTax": 0,
        //         "Width": 1
        //       },
        //       {
        //         "Agent": 0,
        //         "BaseFare": 288,
        //         "BkgType": "",
        //         "BusTypeID": 16,
        //         "BusTypeName": "KARNATAKA SARIGE",
        //         "ChartName": null,
        //         "ChildFare": 144,
        //         "ColumnNo": 3,
        //         "CompanyChartID": 58,
        //         "CompanyChartName": "KS 49 NEW BACK DOOR",
        //         "Deck": 1,
        //         "DefaultCurrencyID": 1,
        //         "Fare": 288,
        //         "GST": 0,
        //         "Gender": "",
        //         "HasDoubleSeaterFemaleValidation": false,
        //         "HasDoubleSlpFemaleValidation": false,
        //         "HasFemaleValidation": false,
        //         "HasGST": 0,
        //         "HasGenderCheck": true,
        //         "HasSCharge": 0,
        //         "HasSTax": 0,
        //         "Height": 1,
        //         "IsAC": false,
        //         "IsAisle": false,
        //         "IsAvailable": 1,
        //         "IsSeatBlockedForCovid19": 0,
        //         "RouteCode": "54~40~1661~894~2024-03-12",
        //         "RowNo": 7,
        //         "SeatLabel": "33",
        //         "SeatTypeID": 1,
        //         "ServiceCharge": 0,
        //         "ServiceTax": 0,
        //         "Width": 1
        //       },
        //       {
        //         "Agent": 0,
        //         "BaseFare": 288,
        //         "BkgType": "",
        //         "BusTypeID": 16,
        //         "BusTypeName": "KARNATAKA SARIGE",
        //         "ChartName": null,
        //         "ChildFare": 144,
        //         "ColumnNo": 4,
        //         "CompanyChartID": 58,
        //         "CompanyChartName": "KS 49 NEW BACK DOOR",
        //         "Deck": 1,
        //         "DefaultCurrencyID": 1,
        //         "Fare": 288,
        //         "GST": 0,
        //         "Gender": "",
        //         "HasDoubleSeaterFemaleValidation": false,
        //         "HasDoubleSlpFemaleValidation": false,
        //         "HasFemaleValidation": false,
        //         "HasGST": 0,
        //         "HasGenderCheck": true,
        //         "HasSCharge": 0,
        //         "HasSTax": 0,
        //         "Height": 1,
        //         "IsAC": false,
        //         "IsAisle": false,
        //         "IsAvailable": 1,
        //         "IsSeatBlockedForCovid19": 0,
        //         "RouteCode": "54~40~1661~894~2024-03-12",
        //         "RowNo": 7,
        //         "SeatLabel": "32",
        //         "SeatTypeID": 1,
        //         "ServiceCharge": 0,
        //         "ServiceTax": 0,
        //         "Width": 1
        //       },
        //       {
        //         "Agent": 0,
        //         "BaseFare": 288,
        //         "BkgType": "",
        //         "BusTypeID": 16,
        //         "BusTypeName": "KARNATAKA SARIGE",
        //         "ChartName": null,
        //         "ChildFare": 144,
        //         "ColumnNo": 5,
        //         "CompanyChartID": 58,
        //         "CompanyChartName": "KS 49 NEW BACK DOOR",
        //         "Deck": 1,
        //         "DefaultCurrencyID": 1,
        //         "Fare": 288,
        //         "GST": 0,
        //         "Gender": "",
        //         "HasDoubleSeaterFemaleValidation": false,
        //         "HasDoubleSlpFemaleValidation": false,
        //         "HasFemaleValidation": false,
        //         "HasGST": 0,
        //         "HasGenderCheck": true,
        //         "HasSCharge": 0,
        //         "HasSTax": 0,
        //         "Height": 1,
        //         "IsAC": false,
        //         "IsAisle": false,
        //         "IsAvailable": 1,
        //         "IsSeatBlockedForCovid19": 0,
        //         "RouteCode": "54~40~1661~894~2024-03-12",
        //         "RowNo": 7,
        //         "SeatLabel": "31",
        //         "SeatTypeID": 1,
        //         "ServiceCharge": 0,
        //         "ServiceTax": 0,
        //         "Width": 1
        //       },
        //       {
        //         "Agent": 0,
        //         "BaseFare": 0,
        //         "BkgType": "",
        //         "BusTypeID": 16,
        //         "BusTypeName": "KARNATAKA SARIGE",
        //         "ChartName": null,
        //         "ChildFare": 0,
        //         "ColumnNo": 0,
        //         "CompanyChartID": 58,
        //         "CompanyChartName": "KS 49 NEW BACK DOOR",
        //         "Deck": 1,
        //         "DefaultCurrencyID": 1,
        //         "Fare": 0,
        //         "GST": 0,
        //         "Gender": "",
        //         "HasDoubleSeaterFemaleValidation": false,
        //         "HasDoubleSlpFemaleValidation": false,
        //         "HasFemaleValidation": false,
        //         "HasGST": 0,
        //         "HasGenderCheck": true,
        //         "HasSCharge": 0,
        //         "HasSTax": 0,
        //         "Height": 1,
        //         "IsAC": false,
        //         "IsAisle": true,
        //         "IsAvailable": 1,
        //         "IsSeatBlockedForCovid19": 0,
        //         "RouteCode": "54~40~1661~894~2024-03-12",
        //         "RowNo": 8,
        //         "SeatLabel": "",
        //         "SeatTypeID": 4,
        //         "ServiceCharge": 0,
        //         "ServiceTax": 0,
        //         "Width": 1
        //       },
        //       {
        //         "Agent": 0,
        //         "BaseFare": 288,
        //         "BkgType": "",
        //         "BusTypeID": 16,
        //         "BusTypeName": "KARNATAKA SARIGE",
        //         "ChartName": null,
        //         "ChildFare": 144,
        //         "ColumnNo": 1,
        //         "CompanyChartID": 58,
        //         "CompanyChartName": "KS 49 NEW BACK DOOR",
        //         "Deck": 1,
        //         "DefaultCurrencyID": 1,
        //         "Fare": 288,
        //         "GST": 0,
        //         "Gender": "",
        //         "HasDoubleSeaterFemaleValidation": false,
        //         "HasDoubleSlpFemaleValidation": false,
        //         "HasFemaleValidation": false,
        //         "HasGST": 0,
        //         "HasGenderCheck": true,
        //         "HasSCharge": 0,
        //         "HasSTax": 0,
        //         "Height": 1,
        //         "IsAC": false,
        //         "IsAisle": false,
        //         "IsAvailable": 1,
        //         "IsSeatBlockedForCovid19": 0,
        //         "RouteCode": "54~40~1661~894~2024-03-12",
        //         "RowNo": 8,
        //         "SeatLabel": "36",
        //         "SeatTypeID": 1,
        //         "ServiceCharge": 0,
        //         "ServiceTax": 0,
        //         "Width": 1
        //       },
        //       {
        //         "Agent": 0,
        //         "BaseFare": 0,
        //         "BkgType": "",
        //         "BusTypeID": 16,
        //         "BusTypeName": "KARNATAKA SARIGE",
        //         "ChartName": null,
        //         "ChildFare": 0,
        //         "ColumnNo": 2,
        //         "CompanyChartID": 58,
        //         "CompanyChartName": "KS 49 NEW BACK DOOR",
        //         "Deck": 1,
        //         "DefaultCurrencyID": 1,
        //         "Fare": 0,
        //         "GST": 0,
        //         "Gender": "",
        //         "HasDoubleSeaterFemaleValidation": false,
        //         "HasDoubleSlpFemaleValidation": false,
        //         "HasFemaleValidation": false,
        //         "HasGST": 0,
        //         "HasGenderCheck": true,
        //         "HasSCharge": 0,
        //         "HasSTax": 0,
        //         "Height": 1,
        //         "IsAC": false,
        //         "IsAisle": true,
        //         "IsAvailable": 1,
        //         "IsSeatBlockedForCovid19": 0,
        //         "RouteCode": "54~40~1661~894~2024-03-12",
        //         "RowNo": 8,
        //         "SeatLabel": "",
        //         "SeatTypeID": 4,
        //         "ServiceCharge": 0,
        //         "ServiceTax": 0,
        //         "Width": 1
        //       },
        //       {
        //         "Agent": 0,
        //         "BaseFare": 288,
        //         "BkgType": "",
        //         "BusTypeID": 16,
        //         "BusTypeName": "KARNATAKA SARIGE",
        //         "ChartName": null,
        //         "ChildFare": 144,
        //         "ColumnNo": 3,
        //         "CompanyChartID": 58,
        //         "CompanyChartName": "KS 49 NEW BACK DOOR",
        //         "Deck": 1,
        //         "DefaultCurrencyID": 1,
        //         "Fare": 288,
        //         "GST": 0,
        //         "Gender": "",
        //         "HasDoubleSeaterFemaleValidation": false,
        //         "HasDoubleSlpFemaleValidation": false,
        //         "HasFemaleValidation": false,
        //         "HasGST": 0,
        //         "HasGenderCheck": true,
        //         "HasSCharge": 0,
        //         "HasSTax": 0,
        //         "Height": 1,
        //         "IsAC": false,
        //         "IsAisle": false,
        //         "IsAvailable": 1,
        //         "IsSeatBlockedForCovid19": 0,
        //         "RouteCode": "54~40~1661~894~2024-03-12",
        //         "RowNo": 8,
        //         "SeatLabel": "37",
        //         "SeatTypeID": 1,
        //         "ServiceCharge": 0,
        //         "ServiceTax": 0,
        //         "Width": 1
        //       },
        //       {
        //         "Agent": 0,
        //         "BaseFare": 288,
        //         "BkgType": "",
        //         "BusTypeID": 16,
        //         "BusTypeName": "KARNATAKA SARIGE",
        //         "ChartName": null,
        //         "ChildFare": 144,
        //         "ColumnNo": 4,
        //         "CompanyChartID": 58,
        //         "CompanyChartName": "KS 49 NEW BACK DOOR",
        //         "Deck": 1,
        //         "DefaultCurrencyID": 1,
        //         "Fare": 288,
        //         "GST": 0,
        //         "Gender": "M",
        //         "HasDoubleSeaterFemaleValidation": false,
        //         "HasDoubleSlpFemaleValidation": false,
        //         "HasFemaleValidation": false,
        //         "HasGST": 0,
        //         "HasGenderCheck": true,
        //         "HasSCharge": 0,
        //         "HasSTax": 0,
        //         "Height": 1,
        //         "IsAC": false,
        //         "IsAisle": false,
        //         "IsAvailable": 1,
        //         "IsSeatBlockedForCovid19": 0,
        //         "RouteCode": "54~40~1661~894~2024-03-12",
        //         "RowNo": 8,
        //         "SeatLabel": "38",
        //         "SeatTypeID": 1,
        //         "ServiceCharge": 0,
        //         "ServiceTax": 0,
        //         "Width": 1
        //       },
        //       {
        //         "Agent": 0,
        //         "BaseFare": 288,
        //         "BkgType": "",
        //         "BusTypeID": 16,
        //         "BusTypeName": "KARNATAKA SARIGE",
        //         "ChartName": null,
        //         "ChildFare": 144,
        //         "ColumnNo": 5,
        //         "CompanyChartID": 58,
        //         "CompanyChartName": "KS 49 NEW BACK DOOR",
        //         "Deck": 1,
        //         "DefaultCurrencyID": 1,
        //         "Fare": 288,
        //         "GST": 0,
        //         "Gender": "F",
        //         "HasDoubleSeaterFemaleValidation": false,
        //         "HasDoubleSlpFemaleValidation": false,
        //         "HasFemaleValidation": false,
        //         "HasGST": 0,
        //         "HasGenderCheck": true,
        //         "HasSCharge": 0,
        //         "HasSTax": 0,
        //         "Height": 1,
        //         "IsAC": false,
        //         "IsAisle": false,
        //         "IsAvailable": 1,
        //         "IsSeatBlockedForCovid19": 0,
        //         "RouteCode": "54~40~1661~894~2024-03-12",
        //         "RowNo": 8,
        //         "SeatLabel": "39",
        //         "SeatTypeID": 1,
        //         "ServiceCharge": 0,
        //         "ServiceTax": 0,
        //         "Width": 1
        //       },
        //       {
        //         "Agent": 0,
        //         "BaseFare": 0,
        //         "BkgType": "",
        //         "BusTypeID": 16,
        //         "BusTypeName": "KARNATAKA SARIGE",
        //         "ChartName": null,
        //         "ChildFare": 0,
        //         "ColumnNo": 0,
        //         "CompanyChartID": 58,
        //         "CompanyChartName": "KS 49 NEW BACK DOOR",
        //         "Deck": 1,
        //         "DefaultCurrencyID": 1,
        //         "Fare": 0,
        //         "GST": 0,
        //         "Gender": "",
        //         "HasDoubleSeaterFemaleValidation": false,
        //         "HasDoubleSlpFemaleValidation": false,
        //         "HasFemaleValidation": false,
        //         "HasGST": 0,
        //         "HasGenderCheck": true,
        //         "HasSCharge": 0,
        //         "HasSTax": 0,
        //         "Height": 1,
        //         "IsAC": false,
        //         "IsAisle": true,
        //         "IsAvailable": 1,
        //         "IsSeatBlockedForCovid19": 0,
        //         "RouteCode": "54~40~1661~894~2024-03-12",
        //         "RowNo": 9,
        //         "SeatLabel": "",
        //         "SeatTypeID": 4,
        //         "ServiceCharge": 0,
        //         "ServiceTax": 0,
        //         "Width": 1
        //       },
        //       {
        //         "Agent": 0,
        //         "BaseFare": 0,
        //         "BkgType": "",
        //         "BusTypeID": 16,
        //         "BusTypeName": "KARNATAKA SARIGE",
        //         "ChartName": null,
        //         "ChildFare": 0,
        //         "ColumnNo": 1,
        //         "CompanyChartID": 58,
        //         "CompanyChartName": "KS 49 NEW BACK DOOR",
        //         "Deck": 1,
        //         "DefaultCurrencyID": 1,
        //         "Fare": 0,
        //         "GST": 0,
        //         "Gender": "",
        //         "HasDoubleSeaterFemaleValidation": false,
        //         "HasDoubleSlpFemaleValidation": false,
        //         "HasFemaleValidation": false,
        //         "HasGST": 0,
        //         "HasGenderCheck": true,
        //         "HasSCharge": 0,
        //         "HasSTax": 0,
        //         "Height": 1,
        //         "IsAC": false,
        //         "IsAisle": true,
        //         "IsAvailable": 1,
        //         "IsSeatBlockedForCovid19": 0,
        //         "RouteCode": "54~40~1661~894~2024-03-12",
        //         "RowNo": 9,
        //         "SeatLabel": "",
        //         "SeatTypeID": 4,
        //         "ServiceCharge": 0,
        //         "ServiceTax": 0,
        //         "Width": 1
        //       },
        //       {
        //         "Agent": 0,
        //         "BaseFare": 0,
        //         "BkgType": "",
        //         "BusTypeID": 16,
        //         "BusTypeName": "KARNATAKA SARIGE",
        //         "ChartName": null,
        //         "ChildFare": 0,
        //         "ColumnNo": 2,
        //         "CompanyChartID": 58,
        //         "CompanyChartName": "KS 49 NEW BACK DOOR",
        //         "Deck": 1,
        //         "DefaultCurrencyID": 1,
        //         "Fare": 0,
        //         "GST": 0,
        //         "Gender": "",
        //         "HasDoubleSeaterFemaleValidation": false,
        //         "HasDoubleSlpFemaleValidation": false,
        //         "HasFemaleValidation": false,
        //         "HasGST": 0,
        //         "HasGenderCheck": true,
        //         "HasSCharge": 0,
        //         "HasSTax": 0,
        //         "Height": 1,
        //         "IsAC": false,
        //         "IsAisle": true,
        //         "IsAvailable": 1,
        //         "IsSeatBlockedForCovid19": 0,
        //         "RouteCode": "54~40~1661~894~2024-03-12",
        //         "RowNo": 9,
        //         "SeatLabel": "",
        //         "SeatTypeID": 4,
        //         "ServiceCharge": 0,
        //         "ServiceTax": 0,
        //         "Width": 1
        //       },
        //       {
        //         "Agent": 0,
        //         "BaseFare": 288,
        //         "BkgType": "",
        //         "BusTypeID": 16,
        //         "BusTypeName": "KARNATAKA SARIGE",
        //         "ChartName": null,
        //         "ChildFare": 144,
        //         "ColumnNo": 3,
        //         "CompanyChartID": 58,
        //         "CompanyChartName": "KS 49 NEW BACK DOOR",
        //         "Deck": 1,
        //         "DefaultCurrencyID": 1,
        //         "Fare": 288,
        //         "GST": 0,
        //         "Gender": "",
        //         "HasDoubleSeaterFemaleValidation": false,
        //         "HasDoubleSlpFemaleValidation": false,
        //         "HasFemaleValidation": false,
        //         "HasGST": 0,
        //         "HasGenderCheck": true,
        //         "HasSCharge": 0,
        //         "HasSTax": 0,
        //         "Height": 1,
        //         "IsAC": false,
        //         "IsAisle": false,
        //         "IsAvailable": 1,
        //         "IsSeatBlockedForCovid19": 0,
        //         "RouteCode": "54~40~1661~894~2024-03-12",
        //         "RowNo": 9,
        //         "SeatLabel": "42",
        //         "SeatTypeID": 1,
        //         "ServiceCharge": 0,
        //         "ServiceTax": 0,
        //         "Width": 1
        //       },
        //       {
        //         "Agent": 0,
        //         "BaseFare": 288,
        //         "BkgType": "",
        //         "BusTypeID": 16,
        //         "BusTypeName": "KARNATAKA SARIGE",
        //         "ChartName": null,
        //         "ChildFare": 144,
        //         "ColumnNo": 4,
        //         "CompanyChartID": 58,
        //         "CompanyChartName": "KS 49 NEW BACK DOOR",
        //         "Deck": 1,
        //         "DefaultCurrencyID": 1,
        //         "Fare": 288,
        //         "GST": 0,
        //         "Gender": "",
        //         "HasDoubleSeaterFemaleValidation": false,
        //         "HasDoubleSlpFemaleValidation": false,
        //         "HasFemaleValidation": false,
        //         "HasGST": 0,
        //         "HasGenderCheck": true,
        //         "HasSCharge": 0,
        //         "HasSTax": 0,
        //         "Height": 1,
        //         "IsAC": false,
        //         "IsAisle": false,
        //         "IsAvailable": 1,
        //         "IsSeatBlockedForCovid19": 0,
        //         "RouteCode": "54~40~1661~894~2024-03-12",
        //         "RowNo": 9,
        //         "SeatLabel": "41",
        //         "SeatTypeID": 1,
        //         "ServiceCharge": 0,
        //         "ServiceTax": 0,
        //         "Width": 1
        //       },
        //       {
        //         "Agent": 0,
        //         "BaseFare": 288,
        //         "BkgType": "",
        //         "BusTypeID": 16,
        //         "BusTypeName": "KARNATAKA SARIGE",
        //         "ChartName": null,
        //         "ChildFare": 144,
        //         "ColumnNo": 5,
        //         "CompanyChartID": 58,
        //         "CompanyChartName": "KS 49 NEW BACK DOOR",
        //         "Deck": 1,
        //         "DefaultCurrencyID": 1,
        //         "Fare": 288,
        //         "GST": 0,
        //         "Gender": "",
        //         "HasDoubleSeaterFemaleValidation": false,
        //         "HasDoubleSlpFemaleValidation": false,
        //         "HasFemaleValidation": false,
        //         "HasGST": 0,
        //         "HasGenderCheck": true,
        //         "HasSCharge": 0,
        //         "HasSTax": 0,
        //         "Height": 1,
        //         "IsAC": false,
        //         "IsAisle": false,
        //         "IsAvailable": 1,
        //         "IsSeatBlockedForCovid19": 0,
        //         "RouteCode": "54~40~1661~894~2024-03-12",
        //         "RowNo": 9,
        //         "SeatLabel": "40",
        //         "SeatTypeID": 1,
        //         "ServiceCharge": 0,
        //         "ServiceTax": 0,
        //         "Width": 1
        //       },
        //       {
        //         "Agent": 0,
        //         "BaseFare": 288,
        //         "BkgType": "",
        //         "BusTypeID": 16,
        //         "BusTypeName": "KARNATAKA SARIGE",
        //         "ChartName": null,
        //         "ChildFare": 144,
        //         "ColumnNo": 0,
        //         "CompanyChartID": 58,
        //         "CompanyChartName": "KS 49 NEW BACK DOOR",
        //         "Deck": 1,
        //         "DefaultCurrencyID": 1,
        //         "Fare": 288,
        //         "GST": 0,
        //         "Gender": "",
        //         "HasDoubleSeaterFemaleValidation": false,
        //         "HasDoubleSlpFemaleValidation": false,
        //         "HasFemaleValidation": false,
        //         "HasGST": 0,
        //         "HasGenderCheck": true,
        //         "HasSCharge": 0,
        //         "HasSTax": 0,
        //         "Height": 1,
        //         "IsAC": false,
        //         "IsAisle": false,
        //         "IsAvailable": 1,
        //         "IsSeatBlockedForCovid19": 0,
        //         "RouteCode": "54~40~1661~894~2024-03-12",
        //         "RowNo": 10,
        //         "SeatLabel": "43",
        //         "SeatTypeID": 1,
        //         "ServiceCharge": 0,
        //         "ServiceTax": 0,
        //         "Width": 1
        //       },
        //       {
        //         "Agent": 0,
        //         "BaseFare": 288,
        //         "BkgType": "",
        //         "BusTypeID": 16,
        //         "BusTypeName": "KARNATAKA SARIGE",
        //         "ChartName": null,
        //         "ChildFare": 144,
        //         "ColumnNo": 1,
        //         "CompanyChartID": 58,
        //         "CompanyChartName": "KS 49 NEW BACK DOOR",
        //         "Deck": 1,
        //         "DefaultCurrencyID": 1,
        //         "Fare": 288,
        //         "GST": 0,
        //         "Gender": "",
        //         "HasDoubleSeaterFemaleValidation": false,
        //         "HasDoubleSlpFemaleValidation": false,
        //         "HasFemaleValidation": false,
        //         "HasGST": 0,
        //         "HasGenderCheck": true,
        //         "HasSCharge": 0,
        //         "HasSTax": 0,
        //         "Height": 1,
        //         "IsAC": false,
        //         "IsAisle": false,
        //         "IsAvailable": 1,
        //         "IsSeatBlockedForCovid19": 0,
        //         "RouteCode": "54~40~1661~894~2024-03-12",
        //         "RowNo": 10,
        //         "SeatLabel": "44",
        //         "SeatTypeID": 1,
        //         "ServiceCharge": 0,
        //         "ServiceTax": 0,
        //         "Width": 1
        //       },
        //       {
        //         "Agent": 0,
        //         "BaseFare": 288,
        //         "BkgType": "",
        //         "BusTypeID": 16,
        //         "BusTypeName": "KARNATAKA SARIGE",
        //         "ChartName": null,
        //         "ChildFare": 144,
        //         "ColumnNo": 2,
        //         "CompanyChartID": 58,
        //         "CompanyChartName": "KS 49 NEW BACK DOOR",
        //         "Deck": 1,
        //         "DefaultCurrencyID": 1,
        //         "Fare": 288,
        //         "GST": 0,
        //         "Gender": "",
        //         "HasDoubleSeaterFemaleValidation": false,
        //         "HasDoubleSlpFemaleValidation": false,
        //         "HasFemaleValidation": false,
        //         "HasGST": 0,
        //         "HasGenderCheck": true,
        //         "HasSCharge": 0,
        //         "HasSTax": 0,
        //         "Height": 1,
        //         "IsAC": false,
        //         "IsAisle": false,
        //         "IsAvailable": 1,
        //         "IsSeatBlockedForCovid19": 0,
        //         "RouteCode": "54~40~1661~894~2024-03-12",
        //         "RowNo": 10,
        //         "SeatLabel": "45",
        //         "SeatTypeID": 1,
        //         "ServiceCharge": 0,
        //         "ServiceTax": 0,
        //         "Width": 1
        //       },
        //       {
        //         "Agent": 0,
        //         "BaseFare": 288,
        //         "BkgType": "",
        //         "BusTypeID": 16,
        //         "BusTypeName": "KARNATAKA SARIGE",
        //         "ChartName": null,
        //         "ChildFare": 144,
        //         "ColumnNo": 3,
        //         "CompanyChartID": 58,
        //         "CompanyChartName": "KS 49 NEW BACK DOOR",
        //         "Deck": 1,
        //         "DefaultCurrencyID": 1,
        //         "Fare": 288,
        //         "GST": 0,
        //         "Gender": "",
        //         "HasDoubleSeaterFemaleValidation": false,
        //         "HasDoubleSlpFemaleValidation": false,
        //         "HasFemaleValidation": false,
        //         "HasGST": 0,
        //         "HasGenderCheck": true,
        //         "HasSCharge": 0,
        //         "HasSTax": 0,
        //         "Height": 1,
        //         "IsAC": false,
        //         "IsAisle": false,
        //         "IsAvailable": 1,
        //         "IsSeatBlockedForCovid19": 0,
        //         "RouteCode": "54~40~1661~894~2024-03-12",
        //         "RowNo": 10,
        //         "SeatLabel": "46",
        //         "SeatTypeID": 1,
        //         "ServiceCharge": 0,
        //         "ServiceTax": 0,
        //         "Width": 1
        //       },
        //       {
        //         "Agent": 0,
        //         "BaseFare": 288,
        //         "BkgType": "",
        //         "BusTypeID": 16,
        //         "BusTypeName": "KARNATAKA SARIGE",
        //         "ChartName": null,
        //         "ChildFare": 144,
        //         "ColumnNo": 4,
        //         "CompanyChartID": 58,
        //         "CompanyChartName": "KS 49 NEW BACK DOOR",
        //         "Deck": 1,
        //         "DefaultCurrencyID": 1,
        //         "Fare": 288,
        //         "GST": 0,
        //         "Gender": "",
        //         "HasDoubleSeaterFemaleValidation": false,
        //         "HasDoubleSlpFemaleValidation": false,
        //         "HasFemaleValidation": false,
        //         "HasGST": 0,
        //         "HasGenderCheck": true,
        //         "HasSCharge": 0,
        //         "HasSTax": 0,
        //         "Height": 1,
        //         "IsAC": false,
        //         "IsAisle": false,
        //         "IsAvailable": 1,
        //         "IsSeatBlockedForCovid19": 0,
        //         "RouteCode": "54~40~1661~894~2024-03-12",
        //         "RowNo": 10,
        //         "SeatLabel": "47",
        //         "SeatTypeID": 1,
        //         "ServiceCharge": 0,
        //         "ServiceTax": 0,
        //         "Width": 1
        //       },
        //       {
        //         "Agent": 0,
        //         "BaseFare": 288,
        //         "BkgType": "",
        //         "BusTypeID": 16,
        //         "BusTypeName": "KARNATAKA SARIGE",
        //         "ChartName": null,
        //         "ChildFare": 144,
        //         "ColumnNo": 5,
        //         "CompanyChartID": 58,
        //         "CompanyChartName": "KS 49 NEW BACK DOOR",
        //         "Deck": 1,
        //         "DefaultCurrencyID": 1,
        //         "Fare": 288,
        //         "GST": 0,
        //         "Gender": "",
        //         "HasDoubleSeaterFemaleValidation": false,
        //         "HasDoubleSlpFemaleValidation": false,
        //         "HasFemaleValidation": false,
        //         "HasGST": 0,
        //         "HasGenderCheck": true,
        //         "HasSCharge": 0,
        //         "HasSTax": 0,
        //         "Height": 1,
        //         "IsAC": false,
        //         "IsAisle": false,
        //         "IsAvailable": 1,
        //         "IsSeatBlockedForCovid19": 0,
        //         "RouteCode": "54~40~1661~894~2024-03-12",
        //         "RowNo": 10,
        //         "SeatLabel": "48",
        //         "SeatTypeID": 1,
        //         "ServiceCharge": 0,
        //         "ServiceTax": 0,
        //         "Width": 1
        //       }
        //     ],
        //     "Status": true
        //   }
        // }
        const busDetails = that.props.search.data.filter(function (a) {
          return that.props.seat.RouteScheduleId === a.RouteScheduleId;
        })[0];
        busDetails.HasSeater
          ? that.setState({ HasSeater: 1 })
          : that.setState({ HasSeater: 0 });
        busDetails.HasSleeper
          ? that.setState({ HasSleeper: 1 })
          : that.setState({ HasSleeper: 0 });
        busDetails.Covid19Config
          ? that.setState({ Covid19Config: true })
          : that.setState({ Covid19Config: false });

        if (data.APIGetChartMicrositeResult.Status) {
          const stchrt = [];
          data.APIGetChartMicrositeResult.Seats.forEach((el) => {
            let baseFare = el.Fare;
            //baseFare -= el.HasSTax ? parseInt(el.ServiceTax, 10) : 0;
            //baseFare -= el.HasSCharge ? parseInt(el.ServiceCharge, 10) : 0;

            const opDisFare = that.props.seat.HasDiscountPolicy
              ? that.props.seat.DiscountAmt > 0
                ? that.props.seat.DiscountAmt
                : Math.round((baseFare * that.props.seat.DiscountPer) / 100)
              : 0;

            baseFare -= baseFare > 0 ? parseInt(opDisFare, 10) : 0;
            el.baseFare = baseFare;
            el.flexiBaseFare  = 0;
            el.flexiBusFare   = 0; 
            stchrt.push(el);
          });
          let flexi                         =  data.APIGetChartMicrositeResult.GroupDiscountFlexi;
          if(flexi && Object.keys(flexi).length > 0){
               let flexibus                 =  flexi.IsGroupDiscountFlexiFare == 1 ? true : false;
               let flexibusPaxCount         =  flexi.FlexiDiscountPaxCount;
               let flexibusAdultFare        =  flexi.FlexiAdultBaseFare;
               let flexibusChildFare        =  flexi.FlexiChildBaseFare;

               that.setState({
                isflexibus : flexibus,
                flexibusPaxCount,
                flexibusAdultFare,
                flexibusChildFare,
               })
          }

          that.setState({ stchrt, seatchart: data.APIGetChartMicrositeResult });
          that.parseSeats();
        } else {
          that.setState({
            error: data.APIGetChartMicrositeResult.ErrorMessage,
          });
          store.dispatch(updateSeatChartErrorMsg(that.props.seat.RouteScheduleId, data.APIGetChartMicrositeResult.ErrorMessage));
        }
      })
      .catch(function (error) {
        console.log(error);
      });
    if (this.props.seoChartactive) {
      let curr;
      if (window.msurl == "shrinath.biz") {
        curr = document.getElementsByClassName("srch-card-sta active");
      } else {
        curr = document.getElementsByClassName("srch-card active");
      }

      const el = curr[curr.length - 1].getBoundingClientRect();
      window.scrollTo(0, el.top);
    }
    window.addEventListener("click", (e) => {
      if (
        window.location.pathname.indexOf("checkout") === -1 &&
        !(
          e.target.className.includes("point-inp") ||
          (e.target.parentNode &&
            e.target.parentNode.className.includes("point-inp")) ||
          (e.target.parentNode &&
            e.target.parentNode.parentNode &&
            e.target.parentNode.parentNode.className.includes("point-inp")) ||
          (e.target.parentNode &&
            e.target.parentNode.parentNode &&
            e.target.parentNode.parentNode.parentNode &&
            e.target.parentNode.parentNode.parentNode.className.includes(
              "point-inp"
            ))
        )
      ) {
        // this.setState({ showPoint: "" });
      }
    });

    document.addEventListener('click', this.handleClickOutside);

    const pickdet =
      this.props.search.stChrtOthrDtls[this.props.seat.RouteScheduleId] &&
      this.props.search.stChrtOthrDtls[this.props.seat.RouteScheduleId].pickups;

    const dropdet =
      this.props.search.stChrtOthrDtls[this.props.seat.RouteScheduleId] &&
      this.props.search.stChrtOthrDtls[this.props.seat.RouteScheduleId]
        .dropPoints;
    const urlParams = new URLSearchParams(window.location.search);
    const linkfromstoptocity = urlParams.get("linkfromstoptocity");
    const linkfromCityId = urlParams.get("linkfromCity");
    const linktoCityId = urlParams.get("linktoCity");
    // const stationInFromCityId = urlParams.get("stationInFromCity");
    // const stationInToCityId = urlParams.get("stationInToCity");
    const stationInFromCityKey = urlParams.get("stationInFromCity");
    const stationInToCityKey = urlParams.get("stationInToCity");
    const stationInFromCity = stationInFromCityKey && stationInFromCityKey.split("|")[1].split(",");
    const stationInToCity = stationInToCityKey && stationInToCityKey.split("|")[1].split(",");
    // const stationInFromCity = stationInFromCityKey && stationInFromCityKey.split("|")[0].replace(/[^a-zA-Z]/g, " ");
    // const stationInToCity = stationInToCityKey && stationInToCityKey.split("|")[0].replace(/[^a-zA-Z]/g, " ");
    var showfromlink = false;
    var showtolink = false;
    var showStationFrom = false;
    var showStationTo = false;
    var pickuplistnew = [];
    var dropofflistnew = [];
    if (linkfromCityId) {
      if (pickdet !== undefined) {
        var key;
        for (key in pickdet) {
          if (pickdet[key].PickupLinkCityId === parseInt(linkfromCityId)) {
            pickuplistnew.push(pickdet[key]);
            showfromlink = true;
          }
        }
      }
      this.setState({ showlinkfromcity: showfromlink, pickuplistnew });
    }

    if (linktoCityId) {
      if (dropdet !== undefined) {
        var key;
        for (key in dropdet) {
          if (dropdet[key].DropLinkCityID === parseInt(linktoCityId)) {
            dropofflistnew.push(dropdet[key]);
            showtolink = true;
          }
        }
      }
      this.setState({ showlinktocity: showtolink, dropofflistnew });
    }

    // filter through pickid

    if (stationInFromCity && stationInFromCity.length > 0) {
      if (pickdet !== undefined) {
        var key;
        for (key in pickdet) {
          if (stationInFromCity.includes(String(pickdet[key].PickupID))) {
            // pickuplistnew.push(...pickdet);
            showStationFrom = true;
            this.setState({ pickStationName: pickdet[key].PickupName, pickStationTime: pickdet[key].PickupTime, pickStationId: pickdet[key].PickupID, pickStationAddress: pickdet[key].Address, pickStationLandmark: pickdet[key].Landmark, pickStationPhone: pickdet[key].ContactNumbers })
          }
        }
      }
      this.setState({ showStationInfromcity: showStationFrom, pickuplistnew });
    }

    // filter through dropId

    if (stationInToCity && stationInToCity.length > 0) {
      if (dropdet !== undefined) {
        var key;
        for (key in dropdet) {
          if (stationInToCity.includes(String(dropdet[key].DropoffID))) {
            // dropofflistnew.push(...dropdet);
            showStationTo = true;
            this.setState({ dropStationName: dropdet[key].DropoffName, dropStationTime: dropdet[key].DropoffTime, dropStationId: dropdet[key].DropoffID })
          }
        }
      }
      this.setState({ showStationIntocity: showStationTo, dropofflistnew });
    }

    // if (stationInFromCity && stationInFromCity.length > 0) {
    //   if (pickdet !== undefined) {
    //     var key;
    //     for (key in pickdet) {
    //       if (pickdet[key].PickupName.toLowerCase().trim() === stationInFromCity.toLowerCase().trim()) {
    //         pickuplistnew.push(...pickdet);
    //         showStationFrom = true;
    //         this.setState({ pickStationName: pickdet[key].PickupName, pickStationTime: pickdet[key].PickupTime, pickStationId: pickdet[key].PickupID, pickStationAddress: pickdet[key].Address, pickStationLandmark: pickdet[key].Landmark, pickStationPhone: pickdet[key].ContactNumbers })
    //       }
    //     }
    //   }
    //   this.setState({ showStationInfromcity: showStationFrom, pickuplistnew });
    // }

    // if (stationInToCity && stationInToCity.length > 0) {
    //   if (dropdet !== undefined) {
    //     var key;
    //     for (key in dropdet) {
    //       if (dropdet[key].DropoffName.toLowerCase().trim() === stationInToCity.toLowerCase().trim()) {
    //         console.log("jsjsjsj");
    //         dropofflistnew.push(...dropdet);
    //         showStationTo = true;
    //         this.setState({ dropStationName: dropdet[key].DropoffName, dropStationTime: dropdet[key].DropoffTime, dropStationId: dropdet[key].DropoffID })
    //       }
    //     }
    //   }
    //   this.setState({ showStationIntocity: showStationTo, dropofflistnew });
    // }



    if (pickuplistnew.length > 0) {
      let linkfare1 = 0;
      if (pickuplistnew[0].PickupChargeRs > 0) {
        linkfare1 = pickuplistnew[0].PickupChargeRs;
      }
      if (
        pickuplistnew[0].PickupChargePer &&
        parseFloat(pickuplistnew[0].PickupChargePer) > 0
      ) {
        linkfare1 = Math.ceil(
          (parseFloat(this.state.seatFare) *
            parseFloat(pickuplistnew[0].PickupChargePer)) /
          100
        );
      }
      // let picklinkTime = pickuplistnew[0].PickupTime;
      // let picklinkcity = pickuplistnew[0].PickupName;
      // let picklinkUpID = pickuplistnew[0].PickupID;
      // let picklinkUpName = pickuplistnew[0].PickupName;
      // let picklinkUpAddress = pickuplistnew[0].Address;
      // let picklinkUpLandmark = pickuplistnew[0].Landmark;
      // let picklinkUpPhone = pickuplistnew[0].ContactNumbers;
      // let pickStationName = pickuplistnew[0].PickupName;
      // let pickStationTime = pickuplistnew[0].PickupTime;
      // let pickStationId = pickuplistnew[0].PickupID;
      // let pickStationAddress = pickuplistnew[0].Address;
      // let pickStationLandmark = pickuplistnew[0].Landmark;
      // let pickStationPhone = pickuplistnew[0].ContactNumbers;

      this.setState({
        linkfare1: linkfare1,
        // picklinkTime,
        // picklinkcity,
        // picklinkUpID,
        // picklinkUpName,
        // picklinkUpAddress,
        // picklinkUpLandmark,
        // picklinkUpPhone,
        // pickStationName,
        // pickStationTime,
        // pickStationId,
        // pickStationAddress,
        // pickStationLandmark,
        // pickStationPhone
      });
    }

    if (dropofflistnew.length > 0) {
      let linkfare2 = 0;
      if (dropofflistnew[0].DropoffChargeRs > 0) {
        linkfare2 = dropofflistnew[0].DropoffChargeRs;
      }
      if (
        dropofflistnew[0].DropoffChargePer &&
        parseFloat(dropofflistnew[0].DropoffChargePer) > 0
      ) {
        linkfare2 = Math.ceil(
          (parseFloat(this.state.seatFare) *
            parseFloat(dropofflistnew[0].DropoffChargePer)) /
          100
        );
      }
      // let droplinktime = dropofflistnew[0].DropoffTime;
      // let droplinkcity = dropofflistnew[0].DropoffName;
      // let droplinkUpID = dropofflistnew[0].DropoffID;
      // let dropStationName = dropofflistnew[0].DropoffName;
      // let dropStationTime = dropofflistnew[0].DropoffTime;
      // let dropStationId = dropofflistnew[0].DropoffID;


      this.setState({
        // linkfare2: linkfare2,
        // droplinktime,
        // droplinkcity,
        // droplinkUpID,
        // dropStationName,
        // dropStationTime,
        // dropStationId
      });
    }
    // const ismantipgurl = window.url + apiUrl.ismantispg;
    // fetchGet(ismantipgurl)
    //   .then(function (data) {
    //     that.setState({ ismantispg: data.ismantispg });
    //   })
    //   .catch(function (error) {
    //     console.log(error);
    //   });
    if (window.customerProfile && window.customerProfile.MobileNumber) {
      const tokenurl =
        window.url +
        apiUrl.getlogintoken +
        "?mobile=" +
        window.customerProfile.MobileNumber;
      fetchGet(tokenurl)
        .then(function (data) {
          if (data.token) {
            that.setState({ logintoken: data.token });
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    }
    const totalOnwardSeats = JSON.parse(sessionStorage.getItem("totalOnwardSeats"));
    //const returnChartSeatRestrictionFlag = this.props.search.searchParams.token && !this.props.search.searchParams.linkfromstoptocity && this.props.search.stChrtStatus[this.props.seat.RouteScheduleId] ? true : false;
    const returnChartSeatRestrictionFlag = this.props.search.searchParams.mode == 'roundtrip' && this.props.search.searchParams.token && this.props.search.stChrtStatus[this.props.seat.RouteScheduleId] ? true : false;

    if (totalOnwardSeats && returnChartSeatRestrictionFlag) {
      this.setState({ totalOnwardSeats: totalOnwardSeats, returnChartSeatRestrictionFlag: returnChartSeatRestrictionFlag })
    }

    this.getLeavyAndConcession(this.props.seat.RouteScheduleId, this.props.search.searchParams.token,this.props.seat.TripCode)

     const bus = this.props.search.data.filter(function (a) {
        return that.props.seat.RouteScheduleId === a.RouteScheduleId;
     })[0];

    //for link ticket 2nd leg make returnTripDiscPer = 0
    if(linkfromstoptocity && this.props.search.searchParams.token){
      this.setState({returnTripDiscPer:0});
    }

  }


  handleClickOutside = (event) => {
    // Select the dropdown element.
    if (this.dropdownRef.current && !this.dropdownRef.current.contains(event.target)) {
      this.setState({ showPoint: "" }); // Close the dropdown
    }
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevState.seatFare !== this.state.seatFare || prevState.pickCharge !== this.state.pickCharge || prevState.dropCharge !== this.state.dropCharge) {
      if (this.state.lvcndata && Object.keys(this.state.lvcndata).length > 0) {
        let onwardLevyConcData = this.state.lvcndata;
        const selSeats = this.state.seatchart.Seats;
        let levyAmt = 0;
        // let groupDiscount = 0;
        let seatsArry = this.state.selSeat;
        if(seatsArry.length >= this.state.flexibusPaxCount && this.state.isflexibus){
          this.updateFlexiBaseFare();
        }else{
          this.updateBaseFare();
        }
        setTimeout(()=>{
             selSeats.forEach((el) => {
                if (this.state.selSeat.indexOf(el.SeatLabel) >= 0) {
                  this.updateOnwardSeatWiseGstNDiscount(el, onwardLevyConcData);
                  let levy = el.l || [];
                  if (levy.length) {
                    levy.forEach(el => {
                      levyAmt += el.a;
                    })
                  }
                  // groupDiscount += el.GroupDiscount;
                }
            })
            this.setState({ levyTotal: levyAmt })
        },100)
      }
      this.calculateGroupDiscount();
    }
  }

  componentWillUnmount() {
    // Remove the event listener when the component is unmounted to avoid memory leaks.
    document.removeEventListener('click', this.handleClickOutside);
  }

updateFlexiBaseFare = () => {
    const selSeats = this.state.seatchart.Seats;
    let tmpBaseFare = 0;
    let tempSeatFare = 0;

    // console.log("this.state.flexibusAdultFare",this.state.flexibusAdultFare);

    if (selSeats && selSeats.length) {
        selSeats.forEach((el) => {
            if (this.state.selSeat.indexOf(el.SeatLabel) >= 0) {
                const flexiBusBaseFare =  this.state.flexibusAdultFare > 0 ? this.state.flexibusAdultFare : el.Fare;
                const flexiBusFare     =  this.state.flexibusAdultFare > 0 ? this.state.flexibusAdultFare : el.Fare;
                el.flexiBusBaseFare    =  Math.ceil(flexiBusBaseFare);
                el.flexiBusFare        =  Math.ceil(flexiBusFare);
                tmpBaseFare            += el.flexiBusBaseFare;
                tempSeatFare           += el.flexiBusFare;
            }
        });

        const roundtmpBaseFare = tmpBaseFare;
        const roundtempSeatFare = tempSeatFare;

        // Only update state if values have changed to avoid unnecessary re-renders
        if (this.state.baseFare !== roundtmpBaseFare || this.state.seatFare !== roundtempSeatFare) {
            this.setState({ baseFare: roundtmpBaseFare, seatFare: roundtempSeatFare });
        }
    }
}

  updateBaseFare = () =>{
    const selSeats = this.state.seatchart.Seats;
    let tmpBaseFare = 0;
    let tempSeatFare = 0;
    if(selSeats && selSeats.length){
        selSeats.forEach((el) => {
          if (this.state.selSeat.indexOf(el.SeatLabel) >= 0) {
            tmpBaseFare+= el.BaseFare ;
            tempSeatFare+= el.Fare;
            el.flexiBusBaseFare = 0;
            el.flexiBusFare = 0;
          }
        })
      this.setState({baseFare:tmpBaseFare,seatFare:tempSeatFare})
    }
  }


  calculateGroupDiscount = () => {
    //console.log("hello");
    const selSeat = this.state.selSeat;
    const selSeats = this.state.seatchart.Seats;
    const levyConcData = this.state.lvcndata;
    const pickCharge = this.state.pickCharge;
    const dropCharge = this.state.dropCharge;
    const totalPickdropCharge = pickCharge + dropCharge;

    const urlParams = new URLSearchParams(window.location.search);
    const linkfromstoptocity = urlParams.get("linkfromstoptocity");

    let discountAmt = 0;
    let groupDiscount = 0;

    let minSeat = ( levyConcData && Object.keys(levyConcData).length > 0 && 
                    levyConcData.GroupDis && Object.keys(levyConcData.GroupDis).length > 0 
                  ) ? levyConcData.GroupDis.MinSeat : 0; 
    // console.log("grpMnseat",minSeat);
    if (this.props.search.searchParams.token && selSeat.length < minSeat) {
      if(levyConcData && Object.keys(levyConcData).length > 0 && levyConcData.IsRetDiscount === 1){
        selSeats.forEach((el) => {
          if (this.state.selSeat.indexOf(el.SeatLabel) >= 0) {
            const baseFare = el.flexiBusBaseFare ? el.flexiBusBaseFare : el.BaseFare;
            discountAmt = Math.floor(((baseFare + totalPickdropCharge) * this.state.returnTripDiscPer) / 100);
            groupDiscount += discountAmt;
          }
        })
      }
    } else {
      if (
        levyConcData && Object.keys(levyConcData).length > 0 &&
        levyConcData.GroupDis && Object.keys(levyConcData.GroupDis).length > 0 &&
        selSeat.length >= levyConcData.GroupDis.MinSeat
      ) {
        //console.log("discount applicable");
        selSeats.forEach((el) => {
          const baseFare =  el.flexiBusBaseFare ? el.flexiBusBaseFare : el.BaseFare;
          if (this.state.selSeat.indexOf(el.SeatLabel) >= 0) {
            if (this.props.search.searchParams.token) {
             
                //for link ticket 2nd leg apply onward discount %
                if(linkfromstoptocity){

                    if (levyConcData.GroupDis.OnwardPtc > 0) {
                      discountAmt = Math.floor(((baseFare + totalPickdropCharge) * levyConcData.GroupDis.OnwardPtc) / 100);
                      groupDiscount += discountAmt;
                    }

                }else{

                    if(levyConcData.IsRetDiscount === 1){
                      if (levyConcData.GroupDis.ReturnPtc > 0) {
                        if (levyConcData.GroupDis.ReturnPtc > this.state.returnTripDiscPer) {
                          discountAmt = Math.floor(((baseFare + totalPickdropCharge) * levyConcData.GroupDis.ReturnPtc) / 100);
                        } else {
                          discountAmt = Math.floor(((baseFare + totalPickdropCharge) * this.state.returnTripDiscPer) / 100);
                        }
        
                        groupDiscount += discountAmt;
                      }
                    }

                }

            } else {
              if (levyConcData.GroupDis.OnwardPtc > 0 && !this.state.isflexibus) {
                const baseFare =  el.flexiBaseFare ? el.flexiBaseFare : el.BaseFare;
                discountAmt = Math.floor(((baseFare + totalPickdropCharge) * levyConcData.GroupDis.OnwardPtc) / 100);
                //console.log("discAmt", discountAmt);
                groupDiscount += discountAmt;
              }
            }

          }
        })
      } else {
        if (this.props.search.searchParams.token) {
          if(levyConcData && Object.keys(levyConcData).length > 0 && levyConcData.IsRetDiscount === 1){
            selSeats.forEach((el) => {
              const baseFare =  el.flexiBusBaseFare ? el.flexiBusBaseFare : el.BaseFare;
              if (this.state.selSeat.indexOf(el.SeatLabel) >= 0) {
                discountAmt = Math.floor(((baseFare + totalPickdropCharge) * this.state.returnTripDiscPer) / 100);
                groupDiscount += discountAmt;
              }
            })
          }
        }
      }
    }
    groupDiscount = Math.floor(groupDiscount)
    this.setState({ groupDiscount })
  }


  updateOnwardSeatWiseGstNDiscount = (onwardSeats, onwardConLevy, type) => {

    const urlParams = new URLSearchParams(window.location.search);
    const linkfromstoptocity = urlParams.get("linkfromstoptocity");

    const onwardSeatCount = this.state.selSeat.length;
    const tmpBaseFare = onwardSeats.flexiBusBaseFare ?  onwardSeats.flexiBusBaseFare : onwardSeats.BaseFare;
    // console.log("tmpBaseFare",tmpBaseFare);

    // console.log("onwardSeats",onwardSeats);
    // console.log("basefare",onwardSeats.BaseFare)
    // console.log("flyBaseFare",onwardSeats.flexiBaseFare);
    // console.log("tmpBaseFare",tmpBaseFare);
    //console.log("onwardConLevy", onwardConLevy);
    //console.log("count number of seats -> ", onwardSeatCount);

    const { pickCharge, dropCharge } = this.state;
    //console.log("pick", { pickCharge, dropCharge })
    //for get corporation lavy ids
    let coLavyIds = "";
    if (
      onwardConLevy && Object.keys(onwardConLevy).length > 0 &&
      onwardConLevy.ConcessionList && onwardConLevy.ConcessionList.length > 0
    ) {
      Object.entries(onwardConLevy.ConcessionList).forEach(([cInd, cObj]) => {
        if (cObj.ConcessionTypeName == 'GENERAL PUBLIC') {
          coLavyIds = cObj.CorporationLavyIDs;
        }
      });
    }

    //console.log('coLavyIds', coLavyIds);

    var discountAmt = 0;
    var totalDiscAmt = 0;
    let minSeat = ( onwardConLevy && Object.keys(onwardConLevy).length > 0 && 
                    onwardConLevy.GroupDis && Object.keys(onwardConLevy.GroupDis).length > 0
                  ) ? onwardConLevy.GroupDis.MinSeat : 0;
    // console.log("meanSeat",minSeat);              
    if (this.props.search.searchParams.token && onwardSeatCount < minSeat) {
      let disBaseFare = tmpBaseFare + pickCharge + dropCharge;
      if(onwardConLevy.IsRetDiscount === 1){
        discountAmt = Math.floor(
          (disBaseFare * this.state.returnTripDiscPer) / 100
        );
      }
    } else {
      if (
        onwardConLevy && Object.keys(onwardConLevy).length > 0 &&
        onwardConLevy.GroupDis && Object.keys(onwardConLevy.GroupDis).length > 0 &&
        onwardSeatCount >= onwardConLevy.GroupDis.MinSeat
      ) {
        // console.log("discount applicable");
        
        let disBaseFare = tmpBaseFare + pickCharge + dropCharge;
        if (this.props.search.searchParams.token) {
          
            if(linkfromstoptocity){

              if (disBaseFare > 0 && onwardConLevy.GroupDis.OnwardPtc > 0) {
                  discountAmt = Math.floor(
                    (disBaseFare * onwardConLevy.GroupDis.OnwardPtc) / 100
                  );
              }

            }else{
              if(onwardConLevy.IsRetDiscount === 1){
                if (disBaseFare > 0 && onwardConLevy.GroupDis.ReturnPtc > 0) {
                    if (onwardConLevy.GroupDis.ReturnPtc > this.state.returnTripDiscPer) {
                      discountAmt = Math.floor(
                        (disBaseFare * onwardConLevy.GroupDis.ReturnPtc) / 100
                      );
                    } else {
                      discountAmt = Math.floor(
                        (disBaseFare * this.state.returnTripDiscPer) / 100
                      );
                    }
                }
              }
            }
            
        } else {
          if (disBaseFare > 0 && onwardConLevy.GroupDis.OnwardPtc > 0 && !this.state.isflexibus) {
            discountAmt = Math.floor(
              (disBaseFare * onwardConLevy.GroupDis.OnwardPtc) / 100
            );
          }
        }
      } else {
        if (this.props.search.searchParams.token && onwardConLevy && Object.keys(onwardConLevy).length > 0 && onwardConLevy.GroupDis == null) {
          let disBaseFare = tmpBaseFare + pickCharge + dropCharge;
          if(onwardConLevy.IsRetDiscount === 1){
            discountAmt = Math.floor(
              (disBaseFare * this.state.returnTripDiscPer) / 100
            );
          }
        }
      }
    }

    var gstPer = 0;
    var gstIsPer = 0;

    //this code is used to get gst percentage from leavy list , where leavy name is GST
    if (
      onwardConLevy && Object.keys(onwardConLevy).length > 0 &&
      onwardConLevy.LevyList && onwardConLevy.LevyList.length > 0
    ) {
      onwardSeats.l = [];
      Object.entries(onwardConLevy.LevyList).forEach(([levyInd, levyObj]) => {
        //if corporatin levy id match with concession corporation levy id then only calculate leavy 
        if (coLavyIds.includes(levyObj.CorporationLevyID)) {
          let fare = 0;
          let levyAmt = 0;
          let calLevyAmt = 0;

          fare = tmpBaseFare + pickCharge + dropCharge;
          levyAmt = levyObj.AdultAmount;

          if (fare >= levyObj.MinBaseFare && fare <= levyObj.MaxBaseFare) {
            if (levyObj.IsPercentage === 0) {
              calLevyAmt = levyAmt;
            } else {
              calLevyAmt = Math.round((fare * levyAmt) / 100);
            }
          }
          onwardSeats.l.push({
            n: levyObj.LevyName,
            a: calLevyAmt,
          });
        }
      });

      Object.entries(onwardConLevy.LevyList).forEach(([levyInd, levyObj]) => {
        if (coLavyIds.includes(levyObj.CorporationLevyID)) {
          if (levyObj.LevyName == "GST") {
            let fare = 0;
            let levyAmt = 0;
            fare = tmpBaseFare + pickCharge + dropCharge;
            levyAmt = levyObj.AdultAmount;

            if (fare >= levyObj.MinBaseFare && fare <= levyObj.MaxBaseFare) {
              if (levyObj.IsPercentage === 0) {
                gstPer = levyAmt;
                gstIsPer = 0;
              } else {
                gstPer = levyAmt;
                gstIsPer = 1;
              }
            }
          }
        }
      })
    }

    //console.log("gstPer", gstPer);
    //console.log("gstIsPer", gstIsPer);

    var baseFare = tmpBaseFare + pickCharge + dropCharge;

    //console.log("basefare", baseFare);

    //for calculate total leavy amt
    var totLeavyAmt = 0;
    if (onwardSeats.l && onwardSeats.l.length > 0) {
      onwardSeats.l.forEach((ol) => {
        if (ol.n !== 'GST') {
          totLeavyAmt += ol.a;
        }
      });
    }

    //console.log("totLeavyAmt", totLeavyAmt);

    var totCancessionAmt = 0;

    let orderData = this.state.orderData;
    if (Object.keys(orderData).length > 0) {
      let onward = orderData.onward;
      let seatDetails = onward.seatDetails;

      Object.keys(seatDetails).forEach(el => {
        if (el == onwardSeats.seatLabel) {
          let conc = onwardSeats[el].c || []
          if (conc.length > 0) {
            conc.forEach(c => totCancessionAmt += c.a)
          }
        }
      })
    }

    if (this.props.search.searchParams.token) {
      totCancessionAmt = 0;
      if (Object.keys(orderData).length > 0) {
        let ret = orderData.return;
        let seatDetails = ret.seatDetails;

        Object.keys(seatDetails).forEach(el => {
          if (el == onwardSeats.seatLabel) {
            let conc = onwardSeats[el].c || []
            if (conc.length > 0) {
              conc.forEach(c => totCancessionAmt += c.a)
            }
          }
        })
      }
    }

    //for whose amount is greater use this amount either concession or discount
    if (discountAmt > totCancessionAmt) {
      totCancessionAmt = 0;
    } else {
      discountAmt = 0;
    }

    //for calculate total concession amt

    var totForGst = baseFare + totLeavyAmt - discountAmt;

    //console.log("totForGst", totForGst);
    var gst = 0;
    var seatWiseIGst = 0;
    var seatWiseCGst = 0;
    var seatWiseSGst = 0;

    if (
      Object.keys(onwardConLevy).length > 0 &&
      onwardConLevy.GSTInfo &&
      Object.keys(onwardConLevy.GSTInfo).length > 0
    ) {
      //corporation has gst for state
      if (
        onwardConLevy.GSTInfo.GSTN != "" &&
        onwardConLevy.GSTInfo.GSTStateCode != ""
      ) {
        //console.log(onwardConLevy.GSTInfo);
        //console.log(onwardConLevy.GSTInfo.GSTN);
        //console.log(onwardConLevy.GSTInfo.GSTStateCode);
        //if customer has gst number

        //customer not have gst then cgst and sgst
        //console.log("customer not have gst then cgst and sgst");
        if (gstIsPer == 1) {
          seatWiseCGst = Math.ceil((totForGst * gstPer) / 100 / 2);
          seatWiseSGst = Math.ceil((totForGst * gstPer) / 100 / 2);
        } else {
          seatWiseCGst = Math.ceil(gstPer / 2);
          seatWiseSGst = Math.ceil(gstPer / 2);
        }
      }
    } else {
      //corporation does not have gst then calculate IGST
      //console.log("corporation does not have gst then calculate IGST");
      if (gstIsPer == 1) {
        seatWiseIGst = Math.ceil((totForGst * gstPer) / 100);
      } else {
        seatWiseIGst = gstPer;
      }
    }

    if (seatWiseIGst > 0) {
      gst = seatWiseIGst;
    }
    else {
      gst = seatWiseCGst + seatWiseSGst;
    }
    // console.log("totForGst",totForGst);
    // console.log("seatWiseIGst", seatWiseIGst);
    // console.log("seatWiseCGst", seatWiseCGst);
    // console.log("seatWiseSGst", seatWiseSGst);
    // console.log("discountAmt", discountAmt);

    // onwardSeats.IGST = seatWiseIGst;
    // onwardSeats.CGST = seatWiseCGst;
    // onwardSeats.SGST = seatWiseSGst;
    onwardSeats.calGst = gst;
    onwardSeats.GroupDiscount = discountAmt;

    if (onwardSeats.l && onwardSeats.l.length > 0) {
      onwardSeats.l.forEach((ol) => {
        if (ol.n == 'GST') {
          ol.a = gst;
        }
      });
    }

    // this.setState({ groupDiscount: discountAmt * onwardSeatCount })
    // console.log("onwardSeats", onwardSeats)
  };

  getLeavyAndConcession(routeId, token,tripCode) {
    const url = window.cdnUrl + apiUrl.getLeavyAndConcession + '?routeCode=' + routeId+'&tripCode='+tripCode;
    let LevyConc = {};
    fetchGet(url)
      .then((data) => {
        let levyDetails = data.LevyList;
        this.setState({ levyDetails, lvcndata: data })
        if (token) {
          LevyConc = { ...this.props.search.levyandConcData, ...data }
        } else {
          LevyConc = data;
        }
        // levyAndConcession[routeId] = data;
        // localStorage.setItem("levyAndConcession", JSON.stringify(levyAndConcession));
        // store.dispatch(updateLevyAndConcession(LevyConc, routeId));
      })
      .catch((err) => {
        console.log(err)
      })
  }

  parseSeats = () => {
    let lower = {};
    let upper = {};
    let fares = [];
    let countLower = this.state.countLower;
    let countUpper = this.state.countUpper;
    const st = this.state.stchrt;
    st.forEach((el) => {
      if (el.baseFare !== 0 && fares.indexOf(el.baseFare) === -1) {
        fares.push(el.baseFare);
      }

      if (el.Deck === 1) {
        if (el.IsAvailable && !el.IsAisle) {
          countLower++;
        }
        if (Object.keys(lower).indexOf(el.ColumnNo + "") === -1) {
          lower[el.ColumnNo] = [];
          if (!el.IsAisle) {
            lower[el.ColumnNo].push(el);
          }
        } else {
          if (!el.IsAisle) {
            lower[el.ColumnNo].push(el);
          }
        }
      } else {
        if (el.IsAvailable && !el.IsAisle) {
          countUpper++;
        }
        if (Object.keys(upper).indexOf(el.ColumnNo + "") === -1) {
          upper[el.ColumnNo] = [];
          if (!el.IsAisle) {
            upper[el.ColumnNo].push(el);
          }
        } else {
          if (!el.IsAisle) {
            upper[el.ColumnNo].push(el);
          }
        }
      }
    });
    lower = this.parseSt(lower);
    upper = this.parseSt(upper);

    const stchrt = { lower, upper };
    this.setState({ stchrt, fares, countLower, countUpper });
  };

  parseSt = (val) => {
    let keys = Object.keys(val);
    for (let i = 0; i < keys.length; i++) {
      if (keys[i + 1] - keys[i] > 1) {
        val[parseInt(keys[i], 10) + 1] = false;
      }
      if (
        val[keys[i]] &&
        val[keys[i]].length === 0 &&
        val[keys[i + 1]] &&
        val[keys[i + 1]].length === 0
      ) {
        val[keys[i]] = false;
        delete val[keys[i + 1]];
      }
    }
    return val;
  };

  showPriceBar = () => {
    const loop = this.state.fares;
    return (
      <div style={{ display: "flex", padding: "5px 0" }}>
        <div
          onClick={() => this.setState({ selFare: 0 })}
          style={
            this.state.selFare === 0
              ? {
                borderBottom: "2px solid",
                borderColor: '#01AEF0',
                color: "#000",
                padding: "5px 10px 2px",
                cursor: "pointer",
              }
              : { padding: "5px 10px 2px", cursor: "pointer" }
          }
        >
          All
        </div>
        {loop.length > 1
          ? loop.map((el) => (
            <div
              key={el}
              style={
                this.state.selFare === el
                  ? {
                    borderBottom: "2px solid",
                    borderColor: color.primary,
                    color: "#000",
                    padding: "5px 10px 2px",
                    cursor: "pointer",
                  }
                  : { padding: "5px 10px 2px", cursor: "pointer" }
              }
              onClick={() => this.setState({ selFare: el })}
            >
              {this.props.search.currency}
              {el}
            </div>
          ))
          : ""}
      </div>
    );
  };

  getHeightForDiv = (el) => {
    for (let i = 0; i < el.length; i++) {
      if (el[i].Width === 1) {
        return "40px";
      } else {
        return "70px";
      }
    }
    return "40px";
  };

  calSeatLabel = (busType, deck) => {

    const isHybridBus = busType && busType.includes('HYBRID') ? true : false;
    //const isSleeperBus = busType && busType.includes('SWIFT-GAJARAJ MULTI AXLE VOLVO A/C SLEEPER BUS') ? true : false;
    const isSleeperBus = busType && busType.includes('SLEEPER') ? true : false;

    let seatLabel = '';
    if (isHybridBus && deck === 'lower') {
      seatLabel = t(SEATER);
    } else if (isHybridBus && deck === 'upper') {
      seatLabel = t(BERTH);
    } else if (isSleeperBus) {
      seatLabel = t(BERTH);
    } else {
      seatLabel = t(SEATER);
    }
    return seatLabel;
  }

  showLowerSt = () => {
    const loop = this.state.stchrt.lower;
    const busType = this.props.search.busType;
    const seatlabel = this.calSeatLabel(busType, 'lower');
    const isSleeperBus = busType && busType.includes('SLEEPER') ? true : false;
    return (
      <div
        style={{
          position: "relative",
          display: "flex",
          flexDirection: "column-reverse",
          justifyContent: "flex-end",
          background: color.white,
          padding: "10px 5px 10px 60px",
          marginBottom: "10px",
          boxShadow: "0 0 2px rgba(0, 0, 0, 0.3)",
          borderRadius: color.borderRadius,
          height:
            this.state.stchrt.upper &&
              Object.keys(this.state.stchrt.upper).length > 0
              ? "unset"
              : "100%",
        }}
      >
        {this.props.DefaultCurrencyID !== 2 ? (
          <span className="seatchart-label">
            {isSleeperBus && t(LOWER)} {seatlabel} ({this.state.countLower})
          </span>
        ) : (
          ""
        )}
        {/* <WheelIcon className="wheelicon" /> */}
        {renderImg('WheelIcon')}
        {this.state.seaterror ? this.showerror() : ""}
        {this.state.singleLadyerror ? this.showSingleLadyError() : ""}
        {Object.keys(loop).map((el, index) => {
          if (loop[el] && loop[el].length > 0) {
            return (
              <div
                key={index}
                style={{
                  position: "relative",
                  display: "flex",
                  height: this.getHeightForDiv(loop[el]),
                }}
              >
                {loop[el].map((ell, indexx) => {
                  const seatcolor =
                    ell.Gender === "F"
                      ? color.female
                      : this.state.selSeat.indexOf(ell.SeatLabel) >= 0 ? color.chekColor : color.green;
                  return (
                    <div
                      key={indexx}
                      style={this.generateSeatStyle(ell)}
                      onClick={() => this.selSeat(ell)}
                      className="seatlook"
                    >
                      {ell.IsAvailable
                        ? ell.DefaultCurrencyID !== 2
                          // ? this.props.search.currency + ell.baseFare
                          ? ell.SeatLabel
                          : ell.SeatLabel
                        : ell.IsSeatBlockedForCovid19
                          ?
                          // covidAmens({ amen: "covid" })
                          renderImg('covid')
                          : ell.SeatLabel}
                      {ell.IsAvailable ? (
                        <span
                          style={{
                            position: "absolute",
                            right: ell.Width === 1 ? "0" : "3px",
                            top: ell.Width === 1 ? "3px" : "initial",
                            bottom: ell.Width === 1 ? "3px" : "0",
                            left: ell.Width === 1 ? "initial" : "3px",
                            width: ell.Width === 1 ? "5px" : "initial",
                            height: ell.Width === 1 ? "initial" : "5px",
                            background: seatcolor,
                          }}
                        ></span>
                      ) : (
                        ""
                      )}
                      <div
                        style={{
                          position: "absolute",
                          top: "35px",
                          right:
                            Object.keys(loop[el]).length / (indexx + 1) > 1.5
                              ? "unset"
                              : "0",
                          left:
                            Object.keys(loop[el]).length / (indexx + 1) > 1.5
                              ? "0"
                              : "unset",
                          width: "max-content",
                          height: "30px",
                          border: "1px solid #f14f22",
                          justifyContent: "center",
                          alignItems: "center",
                          color: "#000",
                          fontSize: "0.75em",
                          padding: "0 10px",
                        }}
                        className="farepopup"
                      >
                        {ell.Height === 1 ? "Seat: " : "Berth: "}
                        {ell.SeatLabel}{" "}
                        {window.msurl === "shwesanthu.com"
                          ? "| Fare: Ks."
                          : window.msurl === "moventis.iamgds.com"
                            ? "| Fare: SAR"
                            : "| Fare: Rs."}{" "}
                        {ell.baseFare}
                      </div>
                    </div>
                  );
                })}
              </div>
            );
          } else {
            return <div key={index} style={{ height: "30px" }}></div>;
          }
        })}
      </div>
    );
  };

  showerror = () => {
    setTimeout(() => {
      this.setState({ seaterror: false });
    }, 5000);
    return (
      <div
        className="errorblock"
        style={{
          bottom:
            this.state.stchrt.upper &&
              Object.keys(this.state.stchrt.upper).length > 0
              ? "-20px"
              : "10px",
        }}
      >
        6 seats are allowed per booking,for more seats please go for multiple
        booking
      </div>
    );
  };

  showSingleLadyError = () => {
    setTimeout(() => {
      this.setState({ singleLadyerror: false });
    }, 2000);
    return (
      <div
        className="errorblock"
        style={{
          bottom:
            this.state.stchrt.upper &&
              Object.keys(this.state.stchrt.upper).length > 0
              ? "-20px"
              : "10px",
        }}
      >
        1 seat is allowed for single lady booking
      </div>
    );
  }
  showUpperSt = () => {
    const loop = this.state.stchrt.upper;
    const busType = this.props.search.busType;
    const seatlabel = this.calSeatLabel(busType, 'upper');
    return (
      <div
        style={{
          position: "relative",
          display: "flex",
          flexDirection: "column-reverse",
          justifyContent: "flex-end",
          background: color.white,
          padding: "10px 5px 10px 60px",
          boxShadow: "0 0 2px rgba(0, 0, 0, 0.3)",
          borderRadius: color.borderRadius,
        }}
      >
        {this.props.DefaultCurrencyID !== 2 ? (
          <span className="seatchart-label up">
            {t(UPPER)} {seatlabel} ({this.state.countUpper} )
          </span>
        ) : (
          ""
        )}
        {Object.keys(loop).map((el, index) => {
          if (loop[el] && loop[el].length > 0) {
            return (
              <div
                key={index}
                style={{
                  position: "relative",
                  display: "flex",
                  height: this.getHeightForDiv(loop[el]),
                }}
              >
                {loop[el].map((ell, indexx) => {
                  const seatcolor =
                    ell.Gender === "F"
                      ? color.female
                      : this.state.selSeat.indexOf(ell.SeatLabel) >= 0 ? color.chekColor : color.green;
                  return (
                    <div
                      key={indexx}
                      style={this.generateSeatStyle(ell)}
                      onClick={() => this.selSeat(ell)}
                      className="seatlook"
                    >
                      {ell.IsAvailable
                        ? ell.DefaultCurrencyID !== 2
                          // ? this.props.search.currency + ell.baseFare
                          ? ell.SeatLabel
                          : ell.SeatLabel
                        : ell.IsSeatBlockedForCovid19
                          ?
                          // covidAmens({ amen: "covid" })
                          renderImg('covid')
                          : ell.SeatLabel}
                      {ell.IsAvailable ? (
                        <span
                          style={{
                            position: "absolute",
                            right: ell.Width === 1 ? "0" : "3px",
                            top: ell.Width === 1 ? "3px" : "initial",
                            bottom: ell.Width === 1 ? "3px" : "0",
                            left: ell.Width === 1 ? "initial" : "3px",
                            width: ell.Width === 1 ? "5px" : "initial",
                            height: ell.Width === 1 ? "initial" : "5px",
                            background: seatcolor,
                          }}
                        ></span>
                      ) : (
                        ""
                      )}
                      <div
                        style={{
                          position: "absolute",
                          top: "-35px",
                          right:
                            Object.keys(loop[el]).length / (indexx + 1) > 1.5
                              ? "unset"
                              : "0",
                          left:
                            Object.keys(loop[el]).length / (indexx + 1) > 1.5
                              ? "0"
                              : "unset",
                          width: "max-content",
                          height: "30px",
                          border: "1px solid #f14f22",
                          justifyContent: "center",
                          alignItems: "center",
                          color: "#000",
                          fontSize: "0.75em",
                          padding: "0 10px",
                        }}
                        className="farepopup"
                      >
                        {ell.Height === 1 ? "Seat: " : "Berth: "}
                        {ell.SeatLabel}{" "}
                        {window.msurl === "shwesanthu.com"
                          ? "| Fare: Ks."
                          : window.msurl === "moventis.iamgds.com"
                            ? "| Fare: SAR"
                            : "| Fare: Rs."}{" "}
                        {ell.baseFare}
                      </div>
                    </div>
                  );
                })}
              </div>
            );
          } else {
            return <div key={index} style={{ height: "30px" }}></div>;
          }
        })}
      </div>
    );
  };

  saveOrder = () => {
    const srchPrms = this.props.search.searchParams;
    let isGenderCheck = 0;
    if (
      this.state.selSeat.length > 0 &&
      (this.state.selPick !== "" || this.state.showlinkfromcity || this.state.showStationInfromcity) &&
      (this.state.selDrop !== "" || this.state.showlinktocity || this.state.showStationIntocity)
    ) {
      const that = this;
      const bus = this.props.search.data.filter(function (a) {
        return that.props.seat.RouteScheduleId === a.RouteScheduleId;
      })[0];
      // let levyAndConcession = {};
      // let lcdata = this.state.lvcndata;
      // if (srchPrms.token) {
      //   let onwardLevyConc = JSON.parse(localStorage.getItem("levyAndConcession"));
      //   if (onwardLevyConc) {
      //     levyAndConcession = onwardLevyConc;
      //     levyAndConcession[bus.RouteScheduleId] = lcdata;
      //     localStorage.setItem("levyAndConcession", JSON.stringify(levyAndConcession));
      //   }
      // } else {
      //   levyAndConcession[bus.RouteScheduleId] = lcdata;
      //   localStorage.setItem("levyAndConcession", JSON.stringify(levyAndConcession));
      // }
      const pick = this.state.selPick;
      const drop = this.state.selDrop;
      let onwardRoundtripDiscountAmt = "";
      let onwardRoundtripDiscountPer = "";
      let returnRoundtripDiscountAmt = "";
      let returnRoundtripDiscountPer = "";
      if (srchPrms.mode === "roundtrip") {
        if (!srchPrms.token) {
          onwardRoundtripDiscountAmt = bus.RoundTripDiscountAmt;
          onwardRoundtripDiscountPer = bus.RoundTripDiscountPer;
        } else {
          returnRoundtripDiscountAmt = bus.RoundTripDiscountAmt;
          returnRoundtripDiscountPer = bus.RoundTripDiscountPer;
        }
      } else {
        const onwardRoundtripDiscountAmt = bus.RoundTripDiscountAmt;
        const onwardRoundtripDiscountPer = bus.RoundTripDiscountPer;
        const returnRoundtripDiscountAmt = bus.RoundTripDiscountAmt;
        const returnRoundtripDiscountPer = bus.RoundTripDiscountPer;
      }
      const source = localStorage.getItem("source");
      const deviceId = localStorage.getItem("deviceId");
      let postData = {
        routeCode: bus.RouteScheduleId,
        BusType: bus.BusType,
        ServiceType: bus.ServiceType,
        companyId: bus.CompanyId,
        companyName: bus.CompanyName,
        suffix: bus.Suffix,
        journeyDate: bus.JourneyDate,
        // pickUpID: pick.PickupID || this.state.picklinkUpID || this.state.pickStationId,
        // pickUpName: pick.PickupName || this.state.picklinkUpName || this.state.pickStationName,
        // pickUpTime: pick.PickupTime || this.state.picklinkTime || this.state.pickStationTime,
        // pickUpAddress: pick.Address || this.state.picklinkUpAddress || this.state.pickStationAddress,
        // pickUpLandmark: pick.Landmark || this.state.picklinkUpLandmark || this.state.pickStationLandmark,
        // pickUpPhone: pick.ContactNumbers || this.state.picklinkUpPhone || this.state.pickStationPhone,
        // dropOffID: drop.DropoffID || this.state.droplinkUpID || this.state.dropStationId,
        // dropOffName: drop.DropoffName || this.state.droplinkcity || this.state.dropStationName,
        // dropOffTime: drop.DropoffTime || this.state.droplinktime || this.state.dropStationTime,
        pickUpID: pick.PickupID || this.state.pickStationId,
        pickUpName: pick.PickupName || this.state.pickStationName,
        pickUpTime: pick.PickupTime || this.state.pickStationTime,
        pickUpAddress: pick.Address || this.state.pickStationAddress,
        pickUpLandmark: pick.Landmark || this.state.pickStationLandmark,
        pickUpPhone: pick.ContactNumbers || this.state.pickStationPhone,
        dropOffID: drop.DropoffID || this.state.dropStationId,
        dropOffName: drop.DropoffName || this.state.dropStationName,
        dropOffTime: drop.DropoffTime || this.state.dropStationTime,
        fromCityName: srchPrms.fromCity.split("|")[1],
        fromCityId: bus.FromCityID,
        toCityName: srchPrms.toCity.split("|")[1],
        toCityId: bus.ToCityID,
        opHasDiscountPolicy: bus.HasDiscountPolicy,
        opDiscountAmt: bus.DiscountAmt,
        opDiscountPer: bus.DiscountPer,
        isNonRefundable: bus.IsNonRefundable,
        onwardRoundtripDisAmt: onwardRoundtripDiscountAmt,
        returnRoundtripDisAmt: returnRoundtripDiscountAmt,
        onwardRoundtripDisPer: onwardRoundtripDiscountPer,
        returnRoundtripDisPer: returnRoundtripDiscountPer,
        covid: bus.TravellerPrecautions || "",
        amenities: bus.AmenitiesType,
        TripCode: bus.TripCode,
        isflexibus:this.state.isflexibus ? 1 : 0,

        mode:
          srchPrms.returnDate && srchPrms.mode === "roundtrip"
            ? "roundtrip"
            : "oneway",
      };
      const selSeats = this.state.seatchart.Seats;
      let index = 0;
      selSeats.forEach((el) => {
        if (this.state.selSeat.indexOf(el.SeatLabel) >= 0) {
          postData["seats[" + index + "]"] = el.SeatLabel;
          postData["gender[" + index + "]"] = this.props.isSingleLady ? 'F' : el.Gender;
          postData["isSleeper[" + index + "]"] =
            el.Width === 2 || el.Height === 2 ? true : false;
          postData["isAC[" + index + "]"] = el.IsAC;
          postData["hasSTax[" + index + "]"] = el.HasSTax;
          postData["serviceTax[" + index + "]"] = 0;//el.ServiceTax;
          postData["hasSCharge[" + index + "]"] = el.HasSCharge;
          postData["serviceCharge[" + index + "]"] = 0;//el.ServiceCharge;
          postData["price[" + index + "]"] = el.flexiBusFare ? el.flexiBusFare : el.Fare;
          // (el.HasSCharge ? parseInt(el.ServiceCharge, 10) : 0) -
          // (el.HasSTax ? parseInt(el.ServiceTax, 10) : 0);
          isGenderCheck =
            el.HasDoubleSeaterFemaleValidation ||
              el.HasDoubleSlpFemaleValidation ||
              el.HasFemaleValidation
              ? 1
              : isGenderCheck;
          postData['childPrice[' + index + ']'] = el.flexiBusFare ? (this.state.flexibusChildFare > 0 ? Math.ceil(this.state.flexibusChildFare) : el.ChildFare) : el.ChildFare;
          //- (el.HasSCharge ? parseInt(el.ServiceCharge, 10) : 0) - (el.HasSTax ? parseInt(el.ServiceTax, 10) : 0);
          index++;
        }
      });
      if (srchPrms.token) {
        postData["token"] = srchPrms.token;
      }
      if (source === 'ios') {
        postData["source"] = 'ios';
      }

      if (this.props.isSingleLady) {
        postData["isSingleLady"] = 1;
      }

      if (deviceId) {
        postData["deviceId"] = deviceId;
      }

      /* if (srchPrms.mode === 'roundtrip' && !srchPrms.token && !srchPrms.linkfromstoptocity) {
        window.sessionStorage.setItem("totalOnwardSeats", JSON.stringify(this.state.totalSeat));
      } */
      if (srchPrms.mode === 'roundtrip' && !srchPrms.token) {
        window.sessionStorage.setItem("totalOnwardSeats", JSON.stringify(this.state.totalSeat));
      }
      if (srchPrms.linkfromstoptocity) {
        postData["trip"] = "connect";
        postData['connectCityParam'] = srchPrms.linkfromstoptocity;
        postData['stophour'] = srchPrms.stophour;
        window.sessionStorage.setItem("startTripJourneyDate", JSON.stringify(srchPrms.departDate));
      }
      // console.log(this.state.pickStationName);
      // console.log("pst", postData);
      let showPassenger = that.props.search.showPassenger;
      showPassenger[bus.RouteScheduleId] = true;
      store.dispatch(updateShowpassenger(showPassenger))
      const url = window.url + apiUrl.orderSave;
      fetchPost(url, postData)
        .then((data) => {
          if (
            postData.mode === "roundtrip" &&
            !srchPrms.token
            // &&data.preHold.isSuccess
          ) {
            let url = '';

            // url =
            //   "/search?mode=roundtrip&fromCity=" +
            //   srchPrms.toCity +
            //   "&toCity=" +
            //   srchPrms.fromCity +
            //   "&departDate=" +
            //   srchPrms.returnDate +
            //   "&returnDate=" +
            //   srchPrms.departDate +
            //   "&token=" +
            //   data.orderToken +
            //   '&stationInFromCity=' +
            //   '&stationInToCity=';

            // window.location.href = url;
            url = window.location.pathname + window.location.search;
            store.dispatch(updateCheckoutDet(data.orderData));
            store.dispatch(updateOrderToken(data.orderToken));
            this.props.history.push(url);
          } else {
            Object.keys(data.orderData.onward.seatDetails).forEach((el) => {
              data.orderData.onward.seatDetails[el]["name"] = "";
              data.orderData.onward.seatDetails[el]["age"] = "";
            });
            if (
              data.orderData.return &&
              data.orderData.return.seatDetails &&
              Object.keys(data.orderData.return.seatDetails).length > 0
            ) {
              Object.keys(data.orderData.return.seatDetails).forEach((el) => {
                data.orderData.return.seatDetails[el]["name"] = "";
                data.orderData.return.seatDetails[el]["age"] = "";
              });
            }

            // that.setState({ showPassenger: true })
            store.dispatch(updateCheckoutDet(data.orderData));
            store.dispatch(updateOrderToken(data.orderToken));
            // if (!data.preHold.isSuccess) {
            //   const error = data.preHold.errorCode;

            //   if (error == "APP104" || error == "APP107" || error == "APP129") {
            //     this.setState({
            //       alerterror:
            //         data.preHold.message +
            //         "\n" +
            //         "Please try with another seats",
            //     });
            //     const url =
            //       "/search?fromCity=" +
            //       srchPrms.fromCity +
            //       "&toCity=" +
            //       srchPrms.toCity +
            //       "&departDate=" +
            //       srchPrms.departDate +
            //       "&returnDate=" +
            //       srchPrms.returnDate +
            //       "&mode=" +
            //       srchPrms.mode;
            //     window.location.href = url;
            //     store.dispatch(updateLoader(false));
            //   } else {
            //     store.dispatch(updateLoader(false));
            //     this.setState({
            //       alerterror:
            //         data.preHold.message +
            //         "\n" +
            //         "Please try with another seats",
            //     });
            //   }
            //   return;
            // }
            // this.handleredirect(data, postData.mode, isGenderCheck);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  HandleEnterSaveOrder = (e) => {
    let that = this;
    const bus = this.props.search.data.filter(function (a) {
      return that.props.seat.RouteScheduleId === a.RouteScheduleId;
    })[0];
    if (e.key === 'Enter') {
      if (Object.keys(this.props.search.order).length > 0) {
        store.dispatch(updateCheckoutDet([]));
        let showPassenger = that.props.search.showPassenger;
        showPassenger[bus.RouteScheduleId] = false;
        store.dispatch(updateShowpassenger(showPassenger));
      } else {
        this.saveOrder();
      }
    }
  }



  handleredirect = (data, mode, isGenderCheck) => {
    let prop = this.props.search.searchParams;
    let { linkfromstoptocity } = prop;
    let isSeamlesspg = this.state.ismantispg;
    let url = "";
    // if (isSeamlesspg) {
    //   const hostname = window.location.hostname;
    //   const coString = "/co/seamless/" + data.orderToken;
    //   const genderstring = "?p=" + isGenderCheck;
    //   const logintoken = "token=" + this.state.logintoken;
    //   let windowurl = "";
    //   if (window.location.hostname.includes("dev.", 0)) {
    //     windowurl = "http://dev.checkout.iamgds.com";
    //   } else if (window.location.hostname.includes("beta.", 0)) {
    //     windowurl = "http://beta.checkout.iamgds.com";
    //   } else {
    //     windowurl = "https://checkout.iamgds.com";
    //   }

    //   if (mode === "roundtrip") {
    //     url = windowurl + coString + "?" + logintoken;
    //   } else {
    //     url = windowurl + coString + genderstring + "&" + logintoken;
    //   }
    //   window.location.href = url;
    // } else {
    if (mode === 'roundtrip' && linkfromstoptocity) {
      // this.props.history.push("/co/exp/" + data.orderToken + '?linkfromstoptocity=' + linkfromstoptocity);
    } else {
      if (mode === "roundtrip") {
        // this.props.history.push("/co/exp/" + data.orderToken);
      } else {
        // this.props.history.push(
        //   "/co/exp/" + data.orderToken + "?p=" + isGenderCheck
        // );
        // this.setState({ showPassenger: true })
      }
    }
    // }
  };
  showPick = () => {
    const prop = this.props.search.searchParams;
    const returnChartSeatRestrictionFlag = this.state.returnChartSeatRestrictionFlag;
    const totalOnwardSeats = this.state.totalOnwardSeats;
    const remainingSeats = totalOnwardSeats - this.state.selSeat.length;
    const roundtripSeatselFlag = (returnChartSeatRestrictionFlag && remainingSeats === 0) ? true : false;
    const seatsCountValidFlag = (roundtripSeatselFlag || (!returnChartSeatRestrictionFlag && this.state.selSeat.length > 0));
    const that = this;
    const bus = this.props.search.data.filter(function (a) {
      return that.props.seat.RouteScheduleId === a.RouteScheduleId;
    })[0];

    let move = prop.mode;
    if (prop.mode === "roundtrip") {
      move = `${t(PROVIDE_PASSENGER_DETAILS)}`;
      // if (!prop.token) {
      //   move = "BOOK RETURN TRIP";
      // }
      // if (!prop.token && prop.linkfromstoptocity) {
      //   move = "BOOK CONNECT TRIP";
      // }
    } else if (Object.keys(this.props.search.order).length > 0 && this.props.search.showPassenger[bus.RouteScheduleId]) {
      move = `${t(CLOSE_CUSTOMER_DETAILS)}`
    } else {
      move = `${t(PROVIDE_PASSENGER_DETAILS)}`;
    }
    return (
      <div className="pickups"
        onKeyDown={(event) => this.state.showPoint === 'drop' && this.handleKeyDown(event, "drop")}>
        <div>
          <div className="points"
            onKeyDown={(event) => this.handleKeyDown(event, "pick")}
          >
            <div
              className={
                this.state.showPoint === "pick"
                  ? "point-inp flex-vc active"
                  : "point-inp flex-vc"
              }
              ref={this.pickupDropdownRef}
              onClick={() => this.setState({ showPoint: "pick" })}
              tabIndex={0}
            >
              {/* <PickupIcon className="lspacerite" /> */}
              {renderImg('PickupIcon')}
              <div
                className={
                  this.state.selPick !== "" ||
                    this.state.showPoint === "pick" ||
                    this.state.showlinkfromcity || this.state.showStationInfromcity
                    ? "picklabel-active"
                    : "picklabel"
                }
              >
                {t(SELECT_BOARDING_POINT)}
                {/* Boarding At Bus Station in {prop.fromCity.split('|')[1]} */}
              </div>
              <span></span>
              <div
                style={{
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                  fontSize: "0.8em",
                  width: "90%",
                  fontWeight: "500",
                  cursor: "pointer",
                }}
              >
                {this.state.showlinkfromcity
                  ? get24HoursTime(this.state.picklinkTime) +
                  " " +
                  this.state.picklinkcity
                  : this.state.showStationInfromcity ? get24HoursTime(this.state.pickStationTime) + " " + this.state.pickStationName : this.state.selPick === ""
                    ? ""
                    : get24HoursTime(this.state.selPick.PickupTime) +
                    " " +
                    this.state.selPick.PickupName}
                {/* {this.state.selPick === ""
                  ? ""
                  : get24HoursTime(this.state.selPick.PickupTime) +
                    " " +
                    this.state.selPick.PickupName} */}
              </div>
            </div>
            <div className="point-sel" style={{ fontSize: "0.75em", paddingTop: "5px" }}>
              {this.state.showlinkfromcity
                ? get24HoursTime(this.state.picklinkTime) +
                " " +
                this.state.picklinkcity
                : this.state.showStationInfromcity ? [renderImg('clock'), get24HoursTime(this.state.pickStationTime) + " " + this.state.pickStationName] : this.state.selPick === ""
                  ? ""
                  : [renderImg('clock'), get24HoursTime(this.state.selPick.PickupTime), " ", this.state.selPick.PickupName]}
              {/* {this.state.selPick === ""
                ? ""
                : get24HoursTime(this.state.selPick.PickupTime) +
                  " " +
                  this.state.selPick.Address} */}
            </div>
            {this.state.showPoint === "pick" && this.showPoint("pick")}
          </div>
          <div className="points"
            onKeyDown={(event) => this.handleKeyDown(event, "drop")}
          >
            <div
              className={
                this.state.showPoint === "drop"
                  ? "point-inp flex-vc active"
                  : "point-inp flex-vc"
              }
              onClick={() => this.setState({ showPoint: "drop" })}
              tabIndex={1}
            >
              {/* <DropoffIcon className="lspacerite" /> */}
              {renderImg('DropoffIcon')}
              <div
                className={
                  this.state.selDrop !== "" ||
                    this.state.showPoint === "drop" ||
                    this.state.showlinktocity || this.state.showStationIntocity
                    ? "picklabel-active"
                    : "picklabel"
                }
              >
                {t(SELECT_DROPPING_POINT)}
                {/* Drop At Bus Station in {prop.toCity.split('|')[1]} */}
              </div>
              <span></span>
              <div
                style={{
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                  fontSize: "0.8em",
                  width: "90%",
                  fontWeight: "500",
                  cursor: "pointer",
                }}
              >
                {this.state.showlinktocity
                  ? get24HoursTime(this.state.droplinktime) +
                  " " +
                  this.state.droplinkcity
                  : this.state.showStationIntocity ? get24HoursTime(this.state.dropStationTime) +
                    " " +
                    this.state.dropStationName : this.state.selDrop === ""
                    ? ""
                    : get24HoursTime(this.state.selDrop.DropoffTime) +
                    " " +
                    this.state.selDrop.DropoffName}
                {/* {this.state.selDrop === ""
                  ? ""
                  : get24HoursTime(this.state.selDrop.DropoffTime) +
                    " " +
                    this.state.selDrop.DropoffName} */}
              </div>
            </div>
            <div className="point-sel" style={{ fontSize: "0.75em", paddingTop: "5px" }}>
              {this.state.showlinktocity
                ? get24HoursTime(this.state.droplinktime) +
                " " +
                this.state.droplinkcity
                : this.state.showStationIntocity ? [renderImg('clock'), get24HoursTime(this.state.dropStationTime) +
                  " " +
                  this.state.dropStationName] : this.state.selDrop === ""
                  ? ""
                  : [renderImg('clock'), get24HoursTime(this.state.selDrop.DropoffTime), " ", this.state.selDrop.DropoffName]}
              {/* {this.state.selDrop === ""
                ? ""
                : get24HoursTime(this.state.selDrop.DropoffTime) +
                  " " +
                  this.state.selDrop.DropoffName} */}
            </div>
          </div>
        </div>
        <div>
          {returnChartSeatRestrictionFlag && totalOnwardSeats > 0 ? this.showReturnSelSeats() : this.showSelSeats()}

          <div
            className="btnPassDetails"
            style={{
              padding: "15px 0",
              textAlign: "center",
              fontWeight: "bold",
              color: Object.keys(this.props.search.order).length > 0 ? "var(--ksrtcThColor2)" : seatsCountValidFlag &&
                (this.state.selPick !== "" || this.state.showlinkfromcity || this.state.showStationInfromcity) &&
                (this.state.selDrop !== "" || this.state.showlinktocity || this.state.showStationIntocity)
                ? color.white
                : "#888",
              background: Object.keys(this.props.search.order).length > 0 ? '#fff' : seatsCountValidFlag &&
                (this.state.selPick !== "" || this.state.showlinkfromcity || this.state.showStationInfromcity) &&
                (this.state.selDrop !== "" || this.state.showlinktocity || this.state.showStationIntocity)
                ? "var(--ksrtcThColor2)" : Object.keys(this.props.search.order).length > 0 ? '#fff'
                  : "#ccc",
              marginTop: "7px",
              borderRadius: color.borderRadius,
              cursor: seatsCountValidFlag &&
                (this.state.selPick !== "" || this.state.showlinkfromcity || this.state.showStationInfromcity) &&
                (this.state.selDrop !== "" || this.state.showlinktocity || this.state.showStationIntocity)
                ? "pointer"
                : "not-allowed",
              boxShadow: seatsCountValidFlag &&
                (this.state.selPick !== "" || this.state.showlinkfromcity || this.state.showStationInfromcity) &&
                (this.state.selDrop !== "" || this.state.showlinktocity || this.state.showStationIntocity)
                ? "none"
                : "none",

              pointerEvents: seatsCountValidFlag &&
                (this.state.selPick !== "" || this.state.showlinkfromcity || this.state.showStationInfromcity) &&
                (this.state.selDrop !== "" || this.state.showlinktocity || this.state.showStationIntocity)
                ? "auto"
                : "none",

              border: Object.keys(this.props.search.order).length > 0 && this.props.search.showPassenger[bus.RouteScheduleId] ? `2px solid ${"var(--ksrtcThColor2)"}` : ''

            }}
            onClick={() => {
              if (Object.keys(this.props.search.order).length > 0) {
                store.dispatch(updateCheckoutDet([]));
                let showPassenger = that.props.search.showPassenger;
                showPassenger[bus.RouteScheduleId] = false;
                store.dispatch(updateShowpassenger(showPassenger));
              } else {
                this.saveOrder();
              }
            }}

            tabIndex={2}
            onKeyDown={(event) => this.HandleEnterSaveOrder(event)}
          >
            {this.state.selPick !== "" && this.state.selDrop !== "" ||
              (this.state.showlinkfromcity && this.state.selDrop !== "") ||
              this.state.showlinktocity || (this.state.showStationInfromcity && this.state.selDrop !== "") || this.state.showStationIntocity
              ? move
              : `${t(SELECT)} ${this.state.selSeat.length === 0 ? t(SEATS) + "," : ""} ${this.state.showlinkfromcity || this.state.showStationInfromcity
                ? ""
                : this.state.selPick === ""
                  ? t(BOARDING) + ","
                  : ""
              } ${this.state.showlinktocity || this.state.showStationIntocity
                ? ""
                : this.state.selDrop === ""
                  ? t(DROPPING_POINT)
                  : ""
              }`}
          </div>
        </div>
        {this.state.showPoint === 'drop' && this.showPoint("drop")}
        {this.state.openfareModal && this.state.selSeat.length > 0 && this.showFareDetails()}
      </div>
    );
  };

  showFareDetails = () => {
    // const { levyArray, levyNameArray } = this.state;
    const seats = this.state.selSeat.length || 0;
    const pickUpCharge = this.state.pickCharge * seats;
    const dropCharge = this.state.dropCharge * seats;
    let levyFare = {};
    const selSeats = this.state.seatchart.Seats;
    selSeats.forEach((el) => {
      if (this.state.selSeat.indexOf(el.SeatLabel) >= 0) {
        let levyList = el.l || [];
        if (levyList.length > 0) {
          levyList.forEach((el) => {
            if (levyFare[el.n] != undefined) {
              levyFare[el.n] += el.a;
            } else {
              levyFare[el.n] = el.a;
            }
          })
        }
      }
    })

    let orderData = this.state.orderData;
    // console.log("orderData", orderData);
    let concessionAmt = 0;
    if (Object.keys(orderData).length > 0) {
      let onward = orderData.onward;
      let seatDetails = onward.seatDetails;

      Object.keys(seatDetails).forEach(el => {
        let conc = seatDetails[el].c || [];
        conc.forEach(c => concessionAmt += c.a)
      })
    }
    let rtConCessionAmt = 0;
    if (orderData.return) {
      //console.log("hi i am in")
      if (Object.keys(orderData).length > 0) {
        let ret = orderData.return;
        let seatDetails = ret.seatDetails;

        Object.keys(seatDetails).forEach(el => {
          let conc = seatDetails[el].c || [];
          conc.forEach(c => rtConCessionAmt += c.a)
        })
      }
    }

    // console.log({ levyArray, levyNameArray });
    return (
      <div className={`chart-fare-details active`}>
        <div className="chart-fare-header">{t(TOTAL_FARE_DETAILS)}</div>
        <div className="chart-fare-container">
          <div className="chart-fare">
            <div>ಮೂಲ ದರ / Original Basic Fare</div>
            <div>{this.props.search.currency}{this.state.baseFare + pickUpCharge + dropCharge}</div>
          </div>
          <div className="chart-fare">
            <div>ರಿಯಾಯಿತಿ ಮೊತ್ತ / Concession Amount</div>
            <div>{"-"}{this.props.search.currency}{rtConCessionAmt > 0 ? rtConCessionAmt : concessionAmt}</div>
          </div>
          <div className="chart-fare">
            <div>ರಿಯಾಯಿತಿ / Discount</div>
            <div>{"-"}{this.props.search.currency}{this.state.groupDiscount > 0 ? this.state.groupDiscount : 0}</div>
          </div>
          {/* <div className="chart-fare">
            <div>ಸ.ಸೇ.ಶು / GST</div>
            <div>{this.props.search.currency}{this.state.gst}</div>
          </div> */}
          {
            this.state.levyTotal > 0 &&
            <div className="chart-fare">
              <div>ಇತರೆ ಶುಲ್ಕಗಳು / Levies</div>
              <div>{this.props.search.currency}{this.state.levyTotal}</div>
            </div>
          }
        </div>
        {/* <div className="last--list">
          <span style={{ fontSize: '12px', color: '#444' }}>{`( `}
            {
              levyNameArray.length > 0 ? (
                levyNameArray.map((val, index) => (
                  <span style={{ fontSize: '12px', color: '#444' }} key={val}>
                    <span>{val}{":"}</span>
                    <span style={{ margin: '0 5px' }}>{levyArray[val]}{levyNameArray.length - 1 > index ? ";" : ''}</span>
                  </span>
                ))
              ) : (null)
            }
            {` )`}</span>
        </div> */}

        {
          Object.keys(levyFare).length > 0 &&
          <div className="last--list">
            <span style={{ fontSize: '0.75em', color: '#444' }}>{`(`}
              {
                Object.keys(levyFare).map((val, index) => (
                  <span style={{ color: '#444', fontWeight: '400' }} key={index}>
                    <span style={{ margin: '0 2px', color: '#444', fontWeight: '400' }}>{val}{":"}</span>
                    <span style={{ margin: '0 2px', color: '#444', fontWeight: '400' }}>{levyFare[val]}{Object.keys(levyFare).length - 1 < index ? ";" : ''}</span>
                  </span>
                ))
              }
              {`)`}</span>
          </div>

        }

      </div>
    )
  }

  showSelSeats = () => {
    if (this.state.selSeat.length > 0) {
      let orderData = this.state.orderData;
      let concessionAmt = 0;
      if (Object.keys(orderData).length > 0) {
        let onward = orderData.onward;
        let seatDetails = onward.seatDetails;

        Object.keys(seatDetails).forEach(el => {
          let conc = seatDetails[el].c || [];
          conc.forEach(c => concessionAmt += c.a)
        })
      }
      let rtConCessionAmt = 0;
      if (this.props.search.searchParams.token) {
        concessionAmt = 0;
        if (Object.keys(orderData).length > 0) {
          let ret = orderData.return;
          let seatDetails = ret.seatDetails;

          Object.keys(seatDetails).forEach(el => {
            let conc = seatDetails[el].c || [];
            conc.forEach(c => rtConCessionAmt += c.a)
          })
        }
      }

      const pickUpCharges = this.state.selSeat.length * this.state.pickCharge;
      const dropCharges = this.state.selSeat.length * this.state.dropCharge;
      const selPaxSeats = this.state.selSeat;
      selPaxSeats.sort(customSort);

      return (
        <React.Fragment>
          <div className="flexed-justify pdinforow">
            <div>{/* this.state.selSeat.join(", ") */}{selPaxSeats.join(", ")}</div>
            <div className="currentprice flex">
              <div>
                <span style={{ color: '#1A1A1A', fontWeight: '600' }}>{t(GRAND_TOTAL)}:{'\u00A0'}
                  {this.props.search.currency}
                  {this.state.disSeatFare
                    ? (this.state.disSeatFare - this.state.groupDiscount + this.state.levyTotal - concessionAmt - rtConCessionAmt + pickUpCharges + dropCharges)
                    : (this.state.seatFare - this.state.groupDiscount + this.state.levyTotal - concessionAmt - rtConCessionAmt + pickUpCharges + dropCharges)}
                </span>
                <span>{'\u00A0'}{'\u00A0'}</span>
                <span
                  onClick={() => { this.setState({ openfareModal: !this.state.openfareModal }) }}
                  style={{ color: '#004F9E', fontSize: '0.875em', fontWeight: '500', cursor: 'pointer' }}
                >
                  {this.state.openfareModal ? `${t(HIDE_DETAILS)}` : `${t(SHOW_DETAILS)}`} {'\u00A0'}
                  {this.state.openfareModal ? <FareDownArrow /> : <FareUpArrow />}
                </span>
              </div>
            </div>
          </div>
        </React.Fragment>
      );
    } else {
      return (
        <div className="instructionmsg">
          {t(SELECT_PDTC)}
        </div>
      );
    }
  };


  showReturnSelSeats = () => {
    const totalOnwardSeats = this.state.totalOnwardSeats;
    const remainingSeats = totalOnwardSeats - this.state.selSeat.length;
    let orderData = this.state.orderData;
    let rtConCessionAmt = 0;
    if (this.props.search.searchParams.token) {
      if (Object.keys(orderData).length > 0) {
        let ret = orderData.return;
        let seatDetails = ret.seatDetails;
        Object.keys(seatDetails).forEach(el => {
          let conc = seatDetails[el].c || [];
          conc.forEach(c => rtConCessionAmt += c.a)
        })
      }
    }

    const pickUpCharges = this.state.selSeat.length * this.state.pickCharge;
    const dropCharges = this.state.selSeat.length * this.state.dropCharge;
    const selPaxSeats = this.state.selSeat;
    selPaxSeats.sort(customSort);

    if ((remainingSeats === 0)) {
      return (
        <React.Fragment>
          {/* {parseInt(this.state.extraFare1) > 0 ||
            this.state.showlinkfromcity ? (
            <div className="flexed-justify pdinforow">
              <div>Link Ticket Service Charge</div>
              <div className="currentprice flex">
                <span>
                  {this.props.search.currency}
                  {parseInt(this.state.extraFare1) * this.state.totalSeat ||
                    parseInt(this.state.linkfare1) * this.state.totalSeat}
                </span>
              </div>
            </div>
          ) : (
            ""
          )}
          {parseInt(this.state.extraFare2) > 0 || this.state.showlinktocity ? (
            <div className="flexed-justify pdinforow">
              <div>Link Ticket Service Charge</div>
              <div className="currentprice flex">
                <span>
                  {this.props.search.currency}
                  {parseInt(this.state.extraFare2) * this.state.totalSeat ||
                    parseInt(this.state.linkfare2) * this.state.totalSeat}
                </span>
              </div>
            </div>
          ) : (
            ""
          )} */}
          <div className="flexed-justify pdinforow">
            <div>{/* this.state.selSeat.join(", ") */}{selPaxSeats.join(", ")}</div>
            <div className="currentprice flex">
              {/* {this.state.seatFare - this.state.disSeatFare > 0 &&
                this.state.disSeatFare > 0 ? (
                <React.Fragment>
                  <span className="greenbg lspacerite flex-all-c">
                    Saved {this.props.search.currency}
                    {this.state.seatFare - this.state.disSeatFare}{" "}
                  </span>
                  <strike className="lspacerite">
                    <span>
                      {this.props.search.currency}
                      {this.state.disSeatFare ? this.state.seatFare + " " : ""}
                    </span>
                  </strike>
                </React.Fragment>
              ) : (
                ""
              )} */}
              <div>
                <span style={{ color: '#1A1A1A', fontWeight: '600' }}>GRAND TOTAL:{'\u00A0'}
                  {this.props.search.currency}
                  {this.state.disSeatFare
                    ? this.state.disSeatFare + this.state.levyTotal - this.state.groupDiscount - rtConCessionAmt + pickUpCharges + dropCharges
                    : this.state.seatFare + this.state.levyTotal - this.state.groupDiscount - rtConCessionAmt + pickUpCharges + dropCharges}
                </span>
                <span>{'\u00A0'}{'\u00A0'}</span>
                <span
                  onClick={() => { this.setState({ openfareModal: !this.state.openfareModal }) }}
                  style={{ color: '#004F9E', fontSize: '0.875em', fontWeight: '500', cursor: 'pointer' }}
                >{"Show Details"}</span>
                {this.state.openfareModal ? <FareDownArrow /> : <FareUpArrow />}
              </div>
            </div>
          </div>
        </React.Fragment>
      );
    } else {
      return (
        <div className="instructionmsg" style={{ display: 'flex', alignItems: 'center', background: '#FFE7E1', textAlign: 'left', fontWeight: '500', color: '#1A1A1A', fontSize: '0.875em', padding: '4px', borderRadius: '4px' }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginRight: '4px' }}>{renderImg('TripIcon')}</div>
          <div >Please select {remainingSeats} berth{remainingSeats > 1 ? 's' : ''}, pick up & drop off location to continue </div>
        </div>
      );
    }
  };

  handleKeyDown = (event, dropdownType) => {
    // console.log("event", event.key);
    const items = document.querySelectorAll(`.point-opt.active .${dropdownType}--val`);
    let currentItemIndex = dropdownType === 'pick' ? this.state.currentpickItemIndex : this.state.currentdropItemIndex;
    if (event.key === 'Tab') {
      event.preventDefault(); // Prevent default tab behavior
      this.setState({ showPoint: dropdownType })
    }
    if (items.length === 1) {
      currentItemIndex = 0;
      // this.setState({ [`current${dropdownType}ItemIndex`]: currentItemIndex })
    }
    if (event.key === 'ArrowDown') {
      event.preventDefault();
      // Move focus to the first item if no item is currently focused
      if (currentItemIndex < items.length - 1) {
        currentItemIndex++;
      } else {
        currentItemIndex = 0;
      }
      this.focusItem(items, currentItemIndex);
      this.setState({ [`current${dropdownType}ItemIndex`]: currentItemIndex })
    }

    if (event.key === 'ArrowUp') {
      event.preventDefault();
      if (currentItemIndex > 0) {
        currentItemIndex--;
      }
      this.focusItem(items, currentItemIndex);
      //this.setState({ currentItemIndex })
      this.setState({ [`current${dropdownType}ItemIndex`]: currentItemIndex })
    }
    if (event.key === 'Enter' && currentItemIndex >= 0) {
      // event.preventDefault();
      const selectedItem = items[currentItemIndex];
      if (selectedItem) {
        items[currentItemIndex].click();
      }
      if (dropdownType === 'pick') {
        let active = document.activeElement;
        // Find the next focusable element
        let allElements = document.querySelectorAll('[tabindex]');
        let target = Array.from(allElements).find(el => el.tabIndex === active.tabIndex + 2);
        if (target) {
          target.focus();
        }
        this.setState({ showPoint: 'drop' })
      }
      if (dropdownType === 'drop') {
        let active = document.activeElement;
        // Find the next focusable element
        let allElements = document.querySelectorAll('[tabindex]');
        let target = Array.from(allElements).find(el => el.tabIndex === active.tabIndex + 3);
        if (target) {
          target.focus();
        }
      }
    }

    if (event.key === 'Enter' && currentItemIndex <= 0) {
      // event.preventDefault();
      this.focusItem(items, 0);
      this.setState({ [`current${dropdownType}ItemIndex`]: 0 })
      const selectedItem = items[0];
      if (selectedItem) {
        items[0].click();
      }
      if (dropdownType === 'pick') {
        let active = document.activeElement;
        // Find the next focusable element
        let allElements = document.querySelectorAll('[tabindex]');
        let target = Array.from(allElements).find(el => el.tabIndex === active.tabIndex + 2);
        if (target) {
          target.focus();
        }
        setTimeout(() => {
          this.setState({ showPoint: 'drop' })
        }, 1000)
      }
      if (dropdownType === 'drop') {
        let active = document.activeElement;
        // Find the next focusable element
        let allElements = document.querySelectorAll('[tabindex]');
        let target = Array.from(allElements).find(el => el.tabIndex === active.tabIndex + 3);
        if (target) {
          target.focus();
        }
      }
    }

  };

  // Function to focus the item at the specified index
  focusItem = (items, index) => {
    if (items[index]) {
      // console.log("Focusing on item:", items[index].textContent); // Debugging
      items[index].focus(); // Focus on the item
    }
  };


  calcFare = (el, sel, chargeRs, chargePer, param) => {
    let extraFare1 =
      param === "pick" ? el[chargeRs] || 0 : this.state.extraFare1;
    let extraFare2 =
      param !== "pick" ? el[chargeRs] || 0 : this.state.extraFare2;

    if (param === "pick" && el[chargePer] && parseFloat(el[chargePer]) > 0) {
      extraFare1 = Math.ceil(
        (parseFloat(this.state.seatFare) * parseFloat(el[chargePer])) / 100
      );
    }
    if (param !== "pick" && el[chargePer] && parseFloat(el[chargePer]) > 0) {
      extraFare2 = Math.ceil(
        (parseFloat(this.state.seatFare) * parseFloat(el[chargePer])) / 100
      );
    }
    let pickCharge = param === "pick" ? el[chargeRs] || 0 : this.state.pickCharge;
    let dropCharge = param === "drop" ? el[chargeRs] || 0 : this.state.dropCharge;
    let showfromStation = this.state.showStationInfromcity;
    let showtoStation = this.state.showStationIntocity;

    if (param === "pick") showfromStation = false;
    if (param === "drop") showtoStation = false;


    this.setState({
      [sel]: el,
      showPoint: "",
      chargePer: el[chargePer],
      chargeRs: el[chargeRs],
      extraFare1,
      extraFare2,
      showStationInfromcity: showfromStation,
      showStationIntocity: showtoStation,
      pickCharge,
      dropCharge
    });
  };

  resetOrder = () =>{
    let that = this;
    const bus = this.props.search.data.filter(function (a) {
      return that.props.seat.RouteScheduleId === a.RouteScheduleId;
    })[0];
    if (Object.keys(this.props.search.order).length > 0 && this.props.search.showPassenger[bus.RouteScheduleId]) {
         store.dispatch(updateCheckoutDet([]));
         let showPassenger = that.props.search.showPassenger;
         showPassenger[bus.RouteScheduleId] = false;
         store.dispatch(updateShowpassenger(showPassenger));

         // console.log("reset order happened...");
      }
  }

  showPoint = (pointtype) => {
    const det =
      this.props.search.stChrtOthrDtls[this.props.seat.RouteScheduleId];
    if (this.state.showPoint == pointtype && det) {
      var loop = this.state.showPoint === "pick" ? det.pickups : det.dropPoints;
      const tm = this.state.showPoint === "pick" ? "PickupTime" : "DropoffTime";
      const title =
        this.state.showPoint === "pick" ? "Pickup Point" : "Dropping Point";
      const name =
        this.state.showPoint === "pick" ? "PickupName" : "DropoffName";
      const sel = this.state.showPoint === "pick" ? "selPick" : "selDrop";
      const chargePer =
        this.state.showPoint === "pick"
          ? "PickupChargePer"
          : "DropoffChargePer";
      const chargeRs =
        this.state.showPoint === "pick" ? "PickupChargeRs" : "DropoffChargeRs";
      const urlParams = new URLSearchParams(window.location.search);
      // const linkroutecheck = urlParams.get("link");
      const linkfromCityId = urlParams.get("linkfromCity");
      const linktoCityId = urlParams.get("linktoCity");
      const stationInFromCityId = urlParams.get("stationInFromCity");
      const stationInToCityId = urlParams.get("stationInToCity");
      var newloop = [];
      if (linkfromCityId && "pick" === pointtype) {
        // var toSearch = "Amaravati";
        if (loop !== undefined) {
          var key;
          for (key in loop) {
            if (loop[key].PickupLinkCityId === parseInt(linkfromCityId)) {
              newloop.push(loop[key]);
            }
          }
        }
      }
      if (linktoCityId && "drop" === pointtype) {
        // var toSearch = "amaravati";
        if (loop !== undefined) {
          var key;
          for (key in loop) {
            if (loop[key].DropLinkCityID === parseInt(linktoCityId)) {
              newloop.push(loop[key]);
            }
          }
        }
      }

      // if (stationInFromCityId && "pick" === pointtype) {
      //   // var toSearch = "Amaravati";
      //   if (loop !== undefined) {
      //     var key;
      //     for (key in loop) {
      //       if (loop[key].PickupID === parseInt(stationInFromCityId)) {
      //         newloop.push(...loop);
      //       }
      //     }
      //   }
      // }
      // if (stationInToCityId && "drop" === pointtype) {
      //   // var toSearch = "amaravati";
      //   if (loop !== undefined) {
      //     var key;
      //     for (key in loop) {
      //       if (loop[key].DropoffID === parseInt(stationInToCityId)) {
      //         newloop.push(...loop);
      //       }
      //     }
      //   }
      // }

      if (newloop.length) {
        loop = newloop;
      }

      return (
        <div className="point-opt active">
          {loop.map((el, index) => {
            return (
              <div
                className={`${this.state.showPoint}--val`}
                key={index}
                onClick={() => {
                  this.calcFare(
                    el,
                    sel,
                    chargeRs,
                    chargePer,
                    this.state.showPoint
                  );
                  // this.resetOrder();
                }
                }
                tabIndex={-1}
              >
                <div className="col-time" style={{ marginLeft: "0px", justifyContent: "flex-start" }}>{renderImg('clock')}{get24HoursTime(el[tm])}</div>
                <div>{el[name]}</div>
                {/* {(el[chargeRs] > 0 || el[chargePer] > 0) && (
                  <div
                    style={{
                      marginLeft: "10px",
                      textAlign: "right",
                      minWidth: "70px",
                    }}
                  >
                    {el[chargePer] > 0
                      ? "(+ " + el[chargePer] + " %)"
                      : el[chargeRs] > 0
                        ? "(+ " + this.props.search.currency + el[chargeRs] + ")"
                        : ""}
                  </div>
                )} */}
              </div>
            );
          })}
        </div>
      );
    } else {
      return <div className="point-opt"></div>;
    }
  };

  showLegend = () => {
    return (
      <div className="legend">
        <div>
          <span style={{ background: "#01AEF0", color: '#000' }}></span>
          {t(SELECTED)}
        </div>
        <div>
          <span style={{ background: color.alto, color: '#000' }}></span>
          {t(BOOKED)}

        </div>
        <div>
          <span className="st-legend" style={{ color: '#000' }}></span>{t(AVAILABLE)}
        </div>
        {/* {this.props.DefaultCurrencyID !== 2 ? (
          <div>
            <span style={{ background: color.male }}></span>
            Male
          </div>
        ) : (
          ""
        )} */}
        {this.props.DefaultCurrencyID !== 2 ? (
          <div>
            <span style={{ background: color.female }}></span>
            {t(FEMALE)}
          </div>
        ) : (
          ""
        )}
        {/* {this.state.HasSeater ? (
          <div>
            <span className="st-legend"></span>Seater
          </div>
        ) : (
          ""
        )} */}
        {/* {this.state.HasSleeper ? (
          <div>
            <span className="st-legend sl"></span>Sleeper
          </div>
        ) : (
          ""
        )} */}
        {this.state.Covid19Config ? (
          <div className="covid-legend">
            <ShieldNoBorder fillcolor="#1EB24B" style={{ marginRight: "5px" }} />
            COVID Safe Bus
          </div>
        ) : (
          ""
        )}
      </div>
    );
  };

  selSeat = (val) => {
    let selSeat = this.state.selSeat;
    let baseFare = this.state.baseFare;
    let gst = this.state.gst;
    let selSeatFare = this.state.selSeatFare;
    let seatFare = this.state.seatFare;
    let disSeatFare = this.state.disSeatFare;
    let showFemalePopup = false;
    let selseatVal = {};
    let totalOnwardSeats = this.state.totalOnwardSeats;
    let returnChartSeatRestrictionFlag = this.state.returnChartSeatRestrictionFlag;
    let maxSeatSelect = 6;
    let levyArray = this.state.levyArray;
    let levyNameArray = this.state.levyNameArray;
    let levyList = this.state.levyDetails;
    let levyAmt = 0;
    let discountAmt = 0;
    let groupDiscount = 0;
    let levyTotal = this.state.levyTotal;
    let levyConcData = this.state.lvcndata;
    if (returnChartSeatRestrictionFlag) {
      maxSeatSelect = totalOnwardSeats || 6;
    }
    let maxSingleLadySelect = 1;
    const that = this;
    const bus = this.props.search.data.filter(function (a) {
      return that.props.seat.RouteScheduleId === a.RouteScheduleId;
    })[0];
    this.setState({ showFemalePopup });
    if (
      val.IsAvailable &&
      (this.state.selFare === 0 || this.state.selFare === val.baseFare)
    ) {
      const index = selSeat.indexOf(val.SeatLabel);


      if (this.props.isSingleLady) {
        if (index === -1 && selSeat.length < maxSingleLadySelect) {
          selSeat.push(val.SeatLabel);
          seatFare += val.Fare;
          // seatFare -= val.HasSCharge ? parseInt(val.ServiceCharge, 10) : 0;
          //seatFare -= val.HasSTax ? parseInt(val.ServiceTax, 10) : 0;
          baseFare += val.BaseFare;
          gst += val.GST;

          if (bus.DiscountAmt > 0 || bus.DiscountPer) {
            let temp = 0;
            temp += val.baseFare;
            disSeatFare += temp;
          }
          // showFemalePopup = true;
          // selseatVal = val;
        } else {

          if (selSeat.length === 1 && index === -1) {
            this.setState({ singleLadyerror: true });
          }
        }
        if (index >= 0) {
          selSeat.splice(index, 1);
          seatFare -= val.Fare;
          //seatFare += val.HasSCharge ? parseInt(val.ServiceCharge, 10) : 0;
          //seatFare += val.HasSTax ? parseInt(val.ServiceTax, 10) : 0;
          baseFare -= val.BaseFare;
          gst -= val.GST;
          if (bus.DiscountAmt > 0 || bus.DiscountPer) {
            let temp = 0;
            temp += val.baseFare;
            disSeatFare -= temp;
          }
        }
      } else {
        if (index === -1 && selSeat.length < maxSeatSelect) {
          selSeat.push(val.SeatLabel);
          seatFare += val.Fare;
          //seatFare -= val.HasSCharge ? parseInt(val.ServiceCharge, 10) : 0;
          //seatFare -= val.HasSTax ? parseInt(val.ServiceTax, 10) : 0;
          const charges = this.state.chargeRs ? this.state.chargeRs : 0;
          baseFare += val.BaseFare;
          gst += val.GST;

          // if (levyList && levyList.length > 0) {

          //   levyList.forEach((levy) => {

          //     if ((val.Fare >= levy.MinBaseFare) && (val.Fare <= levy.MaxBaseFare)) {

          //       if (levyNameArray.indexOf(levy.LevyName) === -1) {
          //         levyNameArray.push(levy.LevyName);
          //       }

          //       if (levy.IsPercentage === 0) {
          //         levyAmt = levy.AdultAmount;
          //       } else {
          //         levyAmt = Math.round((val.Fare * levy.AdultAmount) / 100);
          //       }

          //       if (levyArray[levy.LevyName] != undefined) {
          //         levyArray[levy.LevyName] += levyAmt;
          //       } else {
          //         levyArray[levy.LevyName] = levyAmt;
          //       }

          //       levyTotal += levyAmt;
          //       seatFare += levyAmt;
          //     }
          //   });
          // }

          if (bus.DiscountAmt > 0 || bus.DiscountPer) {
            let temp = 0;
            temp += val.baseFare;
            disSeatFare += temp;
          }
          if (val.Gender === 'F') {
            showFemalePopup = true;
            selseatVal = val;
          }
        } else {
          if (selSeat.length === 6 && index === -1) {
            this.setState({ seaterror: true });
          }
        }
        if (index >= 0) {
          selSeat.splice(index, 1);
          seatFare -= val.Fare;
          //seatFare += val.HasSCharge ? parseInt(val.ServiceCharge, 10) : 0;
          //seatFare += val.HasSTax ? parseInt(val.ServiceTax, 10) : 0;
          baseFare -= val.BaseFare;
          gst -= val.GST;

          // if (levyList && levyList.length > 0) {

          //   levyList.forEach((levy) => {

          //     if ((val.Fare >= levy.MinBaseFare) && (val.Fare <= levy.MaxBaseFare)) {

          //       if (levy.IsPercentage === 0) {
          //         var levyAmt = levy.AdultAmount;
          //       } else {
          //         var levyAmt = ((val.Fare * levy.AdultAmount) / 100).toFixed(0);
          //       }

          //       levyArray[levy.LevyName] -= levyAmt;
          //       seatFare -= levyAmt;
          //       levyTotal -= levyAmt;
          //     }
          //   });
          // }

          if (bus.DiscountAmt > 0 || bus.DiscountPer) {
            let temp = 0;
            temp += val.baseFare;
            disSeatFare -= temp;
          }
        }
      }

      const selSeats = this.state.seatchart.Seats;

      let pickCharge = this.state.pickCharge;
      let dropCharge = this.state.dropCharge;

      let seatsLength = this.state.selSeat.length;

      let totalPickdropCharge = (pickCharge + dropCharge);

      //console.log("totalPickdropCharge", totalPickdropCharge);



      // if (this.props.search.searchParams.token && selSeat.length < 4) {
      //   selSeats.forEach((el) => {
      //     if (this.state.selSeat.indexOf(el.SeatLabel) >= 0) {
      //       discountAmt = Math.floor(
      //         ((el.BaseFare + totalPickdropCharge) * this.state.returnTripDiscPer) / 100
      //       );
      //       groupDiscount += discountAmt;
      //     }
      //   })

      // } else {
      //   if (
      //     levyConcData && Object.keys(levyConcData).length > 0 &&
      //     levyConcData.GroupDis && Object.keys(levyConcData.GroupDis).length > 0 &&
      //     selSeat.length >= levyConcData.GroupDis.MinSeat
      //   ) {
      //     console.log("discount applicable");
      //     selSeats.forEach((el) => {
      //       if (this.state.selSeat.indexOf(el.SeatLabel) >= 0) {
      //         if (this.props.search.searchParams.token) {
      //           if (levyConcData.GroupDis.ReturnPtc > 0) {
      //             if (levyConcData.GroupDis.ReturnPtc > this.state.returnTripDiscPer) {
      //               discountAmt = Math.floor(
      //                 ((el.BaseFare + totalPickdropCharge) * levyConcData.GroupDis.ReturnPtc) / 100
      //               );
      //             } else {
      //               discountAmt = Math.floor(
      //                 ((el.BaseFare + totalPickdropCharge) * this.state.returnTripDiscPer) / 100
      //               );
      //             }

      //             groupDiscount += discountAmt;
      //           }
      //         } else {
      //           if (levyConcData.GroupDis.OnwardPtc > 0) {
      //             discountAmt = Math.floor(
      //               ((el.BaseFare + totalPickdropCharge) * levyConcData.GroupDis.OnwardPtc) / 100
      //             );
      //             groupDiscount += discountAmt;
      //           }
      //         }

      //       }
      //     })
      //   } else {
      //     if (this.props.search.searchParams.token) {
      //       selSeats.forEach((el) => {
      //         if (this.state.selSeat.indexOf(el.SeatLabel) >= 0) {
      //           discountAmt = Math.floor(
      //             ((el.BaseFare + totalPickdropCharge) * this.state.returnTripDiscPer) / 100
      //           );
      //           groupDiscount += discountAmt;
      //         }
      //       })
      //     }
      //   }
      // }

      this.setState({ showPoint: 'pick' })

      if (this.pickupDropdownRef.current) {
        this.pickupDropdownRef.current.focus();
      }

      if (selSeat.length === 0) {
        this.pickupDropdownRef.current.blur();
        // console.log("hell");
        this.setState({ showPoint: "" })
      }
      const totalSeat = selSeat.length;
      this.setState({
        selSeat,
        seatFare,
        disSeatFare,
        selSeatFare,
        totalSeat,
        showFemalePopup,
        selseatVal,
        gst,
        baseFare,
        levyArray,
        levyNameArray,
        levyAmt,
        //levyTotal,
        // groupDiscount
      });
    }
    if (Object.keys(this.props.search.order).length > 0 && this.props.search.showPassenger[bus.RouteScheduleId]) {
      store.dispatch(updateCheckoutDet([]));
      let showPassenger = that.props.search.showPassenger;
      showPassenger[bus.RouteScheduleId] = false;
      store.dispatch(updateShowpassenger(showPassenger));
    }
  };

  closePopup = (param, e) => {
    e.stopPropagation();
    // this.setState({ showFemalePopup: false })
    let selSeat = this.state.selSeat;
    let seatFare = this.state.seatFare;
    let disSeatFare = this.state.disSeatFare;
    let showFemalePopup = false;
    let that = this;
    let val = this.state.selseatVal;
    const index = selSeat.indexOf(val.SeatLabel);
    const bus = this.props.search.data.filter(function (a) {
      return that.props.seat.RouteScheduleId === a.RouteScheduleId;
    })[0];

    if (param === 'cancel') {
      selSeat.splice(index, 1);
      seatFare -= val.Fare;
      //seatFare += val.HasSCharge ? parseInt(val.ServiceCharge, 10) : 0;
      //seatFare += val.HasSTax ? parseInt(val.ServiceTax, 10) : 0;

      if (bus.DiscountAmt > 0 || bus.DiscountPer) {
        let temp = 0;
        temp += val.baseFare;
        disSeatFare -= temp;
      }
    }
    if (param === 'confirm') {
      showFemalePopup = false;
    }
    const totalSeat = selSeat.length;
    this.setState({
      selSeat,
      seatFare,
      disSeatFare,
      totalSeat,
      showFemalePopup,
    });

    setTimeout(() => {
      this.setState({ showPoint: 'pick' });
      if (this.pickupDropdownRef.current) {
        this.pickupDropdownRef.current.focus();
      }
    }, 100);
  }

  showaertdialogue = () => {
    setTimeout(() => {
      this.setState({ alerterror: "" });
    }, 5000);
    return (
      <div
        className="blacklayer"
        onClick={() => {
          this.setState({ alerterror: "" });
        }}
      >
        <div className="popupbox">
          <div className="circle pixedpos logo-box">
            {renderImg('GsbLogoBold')}
          </div>
          <div className="alertmsg">{this.state.alerterror}</div>
          <button
            className="alertbuttonok crsrpointer"
            onClick={() => {
              this.setState({ alerterror: "" });
            }}
          >
            OK{" "}
          </button>
        </div>
      </div>
    );
  };

  loaderShow = () => {
    if (this.state.showLoader) {
      return (
        <div className="loading">
          {/* Loading... */}
          <span></span>
          <span></span>
          <span></span>
        </div>
      )
    } else {
      return null;
    }
  }
  render() {
    let that = this;
    // console.log("orderData", this.state.orderData);
    // console.log(this.props.search.showPassenger);
    const returnChartSeatRestrictionFlag = this.state.returnChartSeatRestrictionFlag;
    const totalOnwardSeats = this.state.totalOnwardSeats;
    const remainingSeats = totalOnwardSeats - this.state.selSeat.length;
    if (this.state.stchrt.lower) {
      return (
        <div className="seatchart">
          {that.state.alerterror !== "" ? that.showaertdialogue() : ""}
          <div className="chartheading flex-vc">
            <div className="seathead">
              {
                returnChartSeatRestrictionFlag && remainingSeats > 0 ?
                  <span style={{ background: '#E82D01', color: '#fff', padding: '4px 5px', borderRadius: '2px', marginRight: '4px' }}>
                    1. Please select {totalOnwardSeats} berth{totalOnwardSeats > 1 ? 's' : ''}
                  </span>
                  : returnChartSeatRestrictionFlag ?
                    <span style={{ background: '#1EB24B', color: '#fff', padding: '4px 12px', borderRadius: '2px', marginRight: '8px' }}>
                      <span style={{ marginRight: '8px' }}>{renderImg('TripMarkIcon')}</span>
                      <span>You’ve selected the berths similar to your onward journey</span>
                    </span>
                    : <span className="flex-vc mspacerite">
                      {/* {this.state.selSeat.length > 0 ? (
                        // <span className="greentickmark"></span>
                        <span></span>
                      ) : (
                        <span className="circle ceruleanbg whiteclr lspacerite">
                          1
                        </span>
                      )} */}
                      <span className="circle ceruleanbg whiteclr lspacerite">
                        1
                      </span>
                      {t(SELECT_SEAT)}
                      {this.state.selSeat.length > 0 &&
                        <span className="greentickmark"></span>
                      }
                    </span>
              }

              {/* {this.showPriceBar()} */}
            </div>
            <div className="pickdrophead">
              <span className="flex-vc">
                {/* {this.state.selSeat.length > 0 &&
                  this.state.selPick !== "" || this.state.showStationInfromcity &&
                  this.state.selDrop !== "" || this.state.showStationIntocity ? (
                  // <span className="greentickmark"></span>
                  <span></span>
                ) : (
                  <span
                    className={`circle lspacerite ${this.state.selSeat.length > 0
                      ? "ceruleanbg whiteclr"
                      : "whitebg lightText1"
                      }`}
                  >
                    2
                  </span>
                )} */}
                <span
                  className={`circle lspacerite ceruleanbg whiteclr`}
                >
                  2
                </span>
                {t(SELECT_PADP)}
                {(this.state.selSeat.length > 0 && this.state.selPick !== "" && this.state.selDrop !== "") &&
                  <span className="greentickmark"></span>
                }
              </span>
            </div>
          </div>
          <div className="seat-wrap" ref={this.dropdownRef}>
            <div className="seats">
              {this.showLowerSt()}
              {this.state.stchrt.upper &&
                Object.keys(this.state.stchrt.upper).length > 0
                ? this.showUpperSt()
                : ""}
            </div>
            {this.showPick()}
          </div>
          {this.showLegend()}
          {this.state.showFemalePopup && <FemaleSeatAlert close={this.closePopup} />}

          {this.showPassengerDetails(this.props.seat.RouteScheduleId)}
        </div>
      );
    } else if (this.props.search.seatChartErrorMsg[this.props.seat.RouteScheduleId] === 'No more Bookings Can be performed on this Trip,Bus is already locked') {
      return (
        <div className="seatchart--err">
          <div>{renderImg('SeatErrorIcon')}</div>
          <div>The journey has started hence online booking is unavailable. Try another journey option.</div>
        </div>
      );
    } else if (this.props.search.seatChartErrorMsg[this.props.seat.RouteScheduleId]) {
      return (
        <div className="seatchart--err">
          <div>{renderImg('SeatErrorIcon')}</div>
          <div>{this.props.search.seatChartErrorMsg[this.props.seat.RouteScheduleId]}</div>
        </div>
      );
    } else {
      return (
        <div className="loading">
          {/* Loading... */}
          <span></span>
          <span></span>
          <span></span>
        </div>
      );
    }
  }

  updateOrderData = (state) => {
    let orderData = state.orderData
    this.setState({ orderData })
  }

  getpickdropData = () =>{
      const pick = this.state.selPick;
      const drop = this.state.selDrop;
    
      let pickDrop = {
        pickUpID: pick.PickupID || this.state.pickStationId,
        pickUpName: pick.PickupName || this.state.pickStationName,
        pickUpTime: pick.PickupTime || this.state.pickStationTime,
        pickUpAddress: pick.Address || this.state.pickStationAddress,
        pickUpLandmark: pick.Landmark || this.state.pickStationLandmark,
        pickUpPhone: pick.ContactNumbers || this.state.pickStationPhone,
        dropOffID: drop.DropoffID || this.state.dropStationId,
        dropOffName: drop.DropoffName || this.state.dropStationName,
        dropOffTime: drop.DropoffTime || this.state.dropStationTime,
      };

      return pickDrop;
  }

  showPassengerDetails = (id) => {
    if (Object.keys(this.props.search.order).length > 0 && this.props.search.showPassenger[id]) {
      return (
        <Passenger
          orderData       = {this.state.orderData}
          updateOrderData = {this.updateOrderData}
          isSingleLady    = {this.state.isSingleLady}
          pickDropData    = {this.getpickdropData()}
        />
      )
    }
    else if (this.props.search.showPassenger[id]) {
      return (
        <div className="loading">
          {/* Loading... */}
          <span></span>
          <span></span>
          <span></span>
        </div>
      );
    }
    else {
      return null;
    }
  }

  generateSeatStyle = (ell) => {
    //  console.log(ell)
    const seatcolor =
      ell.Gender === "F"
        ? color.female
        : this.state.selSeat.indexOf(ell.SeatLabel) >= 0 ? color.chekColor : color.green;
    return {
      // position: 'relative',
      position: "absolute",
      left: ell.RowNo * 35 + "px",
      // top: (ell.RowNo * 35) + 'px',
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: ell.Height * 33 + "px",
      height: ell.Width * 30 + "px",
      margin: "5px",
      fontSize:
        ell.DefaultCurrencyID !== 2
          ? ell.Width === 1
            ? "0.625em"
            : "0.625em"
          : "0.625em",
      paddingRight: !ell.IsAvailable || ell.Width === 2 ? "0" : "5px",
      border: ell.Gender === 'F' ? "2px solid" : '1px solid',
      borderColor: !ell.IsAvailable ? color.alto : seatcolor,
      background: !ell.IsAvailable
        ? "#ccc"
        : this.state.selSeat.indexOf(ell.SeatLabel) >= 0
          ? ell.Gender === 'F' ? 'rgba(236, 18, 135, 0.15)' : seatcolor
          : color.white,
      color:
        !ell.IsAvailable
          // || this.state.selSeat.indexOf(ell.SeatLabel) >= 0
          ? "#202020"
          : this.state.selSeat.indexOf(ell.SeatLabel) >= 0 ? ell.Gender === 'F' ? '#444' : "#fff" : "#444",
      opacity:
        this.state.selFare !== 0 && this.state.selFare !== ell.baseFare
          ? 0.2
          : 1,
      userSelect: "none",
      cursor: ell.IsAvailable ? "pointer" : "not-allowed",
      fontWeight: '500',
    };
  };
}

const mapStateToProps = function (store) {
  return store;
};

export default connect(mapStateToProps)(withRouter(Seatchart));
